/**
 * Cart event handler - External JS file version
 * File: jsc-reset-scripts.js
 */

// Define the cartJSEvent function for global access
window.cartJSEvent = function() {
  console.log('Binding cart.requestStarted and cart.requestComplete from external file');
  
  // Check if jQuery is available
  if (typeof jQuery === 'undefined' && typeof $ === 'undefined') {
    console.error('jQuery not available in external file');
    return false;
  }
  
  // Force use jQuery in non-conflicting mode
  (function($) {
    // Direct event binding with verification
    $(document).on('cart.requestStarted', function(event, cart) {
      console.log('cart.requestStarted fired');
      $('.jsc-page-loading').show();
    });
    
    $(document).on('cart.requestComplete', function(event, cart) {
      console.log('cart.requestComplete fired');
      $('.jsc-page-loading').hide();
      
      if ($('#Cart-Drawer').length > 0) {
        document.dispatchEvent(new CustomEvent('customcart:refresh'));
      }
      
      if ($('.main-cart-section').length > 0) {
        document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
      }
    });
    
    // Verify events are properly bound
    console.log('Events bound successfully from external file');
    
  })(window.jQuery || window.$); // Support both jQuery and $ in Shopify
  
  console.log('Cart events initialization complete from external file');
  return true;
};

// Attempt to auto-initialize if jQuery is already available
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded in external file - checking for jQuery');
  if (window.jQuery || window.$) {
    console.log('jQuery found in external file, auto-initializing');
    window.cartJSEvent();
  } else {
    console.log('jQuery not yet available in external file, will be initialized from inline script');
  }
});
var masterpromorunThemeATC = false;
$(function () {
  //cartJSEvent();
  intervalshowfestivegif();
  renderFeatCollTextColor();
  $(document).click(function(e){
    var container = $(".jsc-store-list-wrap");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $('.shopLinkList').hide();
    }
    var container = $(".jsc-select-currency");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $('.jsc-select-currency .currencyList').hide();
    }
  });
  getUserIPInfo();
  if ( $('.product-slider-pdp').length > 0 ) {
    onloadGetProductImgArray();
  }
  $('.jsc-link-container').off('click').on('click', headerbgchange);
  if (location.href.includes('.jp')) {
    $('[href="https://www.beyondthevines.com/a/return"]').text('www.beyondthevines.jp/a/return');
    $('[href="https://www.beyondthevines.com/a/return"]').attr('href','https://www.beyondthevines.jp/a/return');
  }else if (location.href.includes('.ph')) {
    $('[href="https://www.beyondthevines.com/a/return"]').text('www.beyondthevines.ph/a/return');
    $('[href="https://www.beyondthevines.com/a/return"]').attr('href','https://www.beyondthevines.ph/a/return');
  }
  $(document).on('click', '.shg-box-linked', function(evt) {
    var link = $(this).attr('data-shg-href');
    window.location.href = link;
  });
  //gwpPopupATCfirstload();
  updateGridHeight();
  updateGridHeightcollection();
  updateGridHeightrecommendation();
  updateGridHeightblog();
  updateFeatCollContainerHeight();
  // updateMobileImage(); //featured collection mobile image
  featureCollectionAutoTitleSwitcher();
  preventSearchBarToScroll();
  var disabled;
  swapvipcheck(disabled,true);
  earlyaccesslimit();
  onloadlabelcheck();
  masterPromo();
  handleGiftWrapChange();
  handleGiftWrapChangeCartDrawer();
  cartNotesToggle();
  onloadchecksoldoutBundle();
  onloadselectcolbundle();
  showPopupSection();
  datePickerListener();
  initFaqSlider();
  initComplementary();
  updateFaqID();
  applyToSelectInput();
  initCartDrawerYMLSlider();
  initFeaturedCollectionSlider();
  featureCollectionAutoTitleSwitcherSlider();
  checkScreenSizeForOrderPagination();
  checkAndUpdateReturnGoButtonText();
  shopLookHover();
  checkShogunPages();
  $(".product-add-to-cart-sticky--inner").on("click", function() {
    updateProductAddToCartSticky();
  });
  $(document).on('click', '.ReturnGO_UploadImages-module_upload', function() {
    handleUploadButtonClick();
  });
    initflickityCarouselPage();
  initflickityCarouselstorePageonclick();

  //Marquee
  // var clonenewMarquee = $(".js-marquee").first().find('div:not(.js-marquee)').clone();
  // $("#scroll_textblog").children().remove();
  // $("#scroll_textblog").append(clonenewMarquee);
  newMarquee();
  newBlogMarquee();

  appendtogglesize();
  $(".tablesizelist ul.tabs a").click(function() {
    $(".tablesizelist ul.tabs a").removeClass('js-active');
    $(".tablesizelist ul.tabs-content li").removeClass('active');
    $(".tabs-content " +$(this).attr("href")).addClass('active');
    $(this).addClass('js-active');
    if($(this).text() == "Size Conversion"){
      $(".tablesizelist .togglesize").hide();
    }else{
      $(".tablesizelist .togglesize").show();
    }
  });
  $("#viewSize span").click(function() {
    $(".sizepopupoverlay").show();
    $(".sizepopup").show();
    $("body").css('overflow', 'hidden');
  });

  initWrapperCloseButton();
  changeProductNoteToSentenceCase();
  $(window).resize(function() {
    updateFeatCollContainerHeight();
  });
  var flickityCheck = setInterval(function() {
    console.log("Checking the flickity");
    if (typeof $.fn.flickity === 'function') {
      console.log('Flickity is loaded and ready to use.');
      clearInterval(flickityCheck);
      initswatchflickity();
    }
  }, 10);
});

//swap variant label - start
swaplabel = (evt) => {
  setTimeout(function () {

    //hide all variant label
    $(evt).parents('.product-information--inner').find(".jsc-var-label").hide();
    $(evt).parents('.product-information--inner').find(".jsc-var-label").each(function () {
      var datavarid = $(this).attr('data-label-id');
      //check each of variant that is equal to variant id then show
      if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
        $(this).show();
      }
    });

    $('.label-qty-wrap-qv').show();
    var hasLabel = false;
    $('.hide-sold-label').hide(); //This hide the sold label when there is notify button - #10574
    $(evt).parents('.product-information--inner').find(".jsc-label").each(function () {
      if($(this).is(":visible")){
        hasLabel = true;
      }
    });
    if (hasLabel) {
      $('.label-qty-wrap-qv').show();
    }else{
      $('.label-qty-wrap-qv').hide();
    }

  }, 10);
};

onloadlabelcheck = () => {
  $('.product-information--inner').each(function () {
    var hasLabel = false;
    $(this).find(".jsc-label").each(function () {
      if($(this).is(":visible")){
        hasLabel = true;
      }
    });
    if (hasLabel) {
      $(this).find('.label-qty-wrap-qv').show();
    }else{
      $(this).find('.label-qty-wrap-qv').hide();
    }
  });
};
//swap variant label - end

//swap variant image - start
var $imgContainer = $('.product-slider-pdp');
var $childArrayElement = $imgContainer.find('.product-images__slide');
var $navContainer = $('.selectedNav');
var $navCell = $('.navCell');

onloadGetProductImgArray = () =>{
  var $isShow = false;
  var $bundleColor = '';
  var $selectedColor = $('.pdp-section-info .variations .product-form__input--color input[type="radio"]:checked').val();
  if ($selectedColor !== undefined && $selectedColor !== '') {
    $selectedColor = $selectedColor.toLowerCase();
  }
  if ($(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').each(function () {
      bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
    });
    bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
    $bundleColor = bundlecolor;
  }
  var $prodTitle = $('.pdp-section-info .product-title').attr('data-title').toLowerCase();
  if ($(".pdp-section-info .prod-bundle-select").length > 1) {
    $selectedColor = $prodTitle;
  }

  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();
 
  // remove all product image
  $imgContainer.children().remove();
  $navCell.remove();
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
    if ($childArrayElement[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $imgContainer.append($childArrayElement[i]);
      $isShow = true;
    }
    }
  }
  
  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = $($navCell[i]).attr('data-img-alt').toLowerCase();
    if ($navCell[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $navContainer.append($navCell[i]);
      $isShow = true;
    }
    }
  }

  $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchchild = $(this).val().toLowerCase();

      for (var i = 0; i < $childArrayElement.length; i++) {
        if ($childArrayElement[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
            $imgContainer.append($childArrayElement[i]);
            }
            $isShow = true;
          }
        }
      }

      for (var i = 0; i < $navCell.length; i++) {
        if ($navCell[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCell[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
            $navContainer.append($navCell[i]);
            }
            $isShow = true;
          }
        }
      }
  });
  
  //initiate flickity function
  initProductSlider($isShow);
  initNavSlider();

  var prevWidth = window.innerWidth;

  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    // Destroy slider
    destroyProductSlider();
    destroyNavSlider();
    initProductSlider(true);
    initNavSlider();
    }

  });
}

variantImageSwap = (color,bundle) =>{
  setTimeout(() => {
    var $isShow = false;
    var $bundleColor = '';
    if (bundle) {
      var $selectedColor = $(".swatch_options.bundle-child-swatch input:checked").first().val().toLowerCase();
    }else{
      var $selectedColor = color.toLowerCase();
    }
    if ($(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').length > 1) {
      var bundlecolor = '';
      $(".pdp-section-info .variations").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
        bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
      });
      bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
      $bundleColor = bundlecolor;
    }
    var $prodTitle = $('.pdp-section-info .product-title').attr('data-title').toLowerCase();
  
    // Destroy slider
    destroyProductSlider();
    destroyNavSlider();
  
    // remove all product image
    $imgContainer.children().remove();
    $navCell.remove();
    
    // Loop and append the correct cell
    for (var i = 0; i < $childArrayElement.length; i++) {
      var $thisAltText = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
      if ($childArrayElement[i].classList.contains('bundlevarimg')) {
        
      }else{
      if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
        $imgContainer.append($childArrayElement[i]);
        $isShow = true;
      }
      }
    }
    
    // Loop and append the correct cell for nav img slider
    for (var i = 0; i < $navCell.length; i++) {
      var $thisAltText = $($navCell[i]).attr('data-img-alt').toLowerCase();
      if ($navCell[i].classList.contains('bundlevarimg')) {
        
      }else{
      if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
        $navContainer.append($navCell[i]);
        $isShow = true;
      }
      }
    }

    if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
    $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
      var productIndex = index + 1;
      var $swatchchild = $(this).val().toLowerCase();
  
        for (var i = 0; i < $childArrayElement.length; i++) {
          if ($childArrayElement[i].classList.contains('bundlevarimg_' + productIndex)) {
          var $alt = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $imgContainer.append($childArrayElement[i]);
            }
          }
        }
  
        for (var i = 0; i < $navCell.length; i++) {
          if ($navCell[i].classList.contains('bundlevarimg_' + productIndex)) {
          var $alt = $($navCell[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $navContainer.append($navCell[i]);
            }
          }
        }
    });
  }else{

    $(".pdp-section-info .prod-bundle-select .swatch_options.bundle-child-swatch .swatchbundlecol input:checked").each(function (index) {
      var productIndex = index + 1;
      var $swatchchild = $(this).val().toLowerCase();
      var swatchprodid = $(this).attr('data-product-id');
  
        for (var i = 0; i < $childArrayElement.length; i++) {
          if ($childArrayElement[i].classList.contains('bundlevarimg_' + swatchprodid)) {
          var $alt = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $imgContainer.append($childArrayElement[i]);
            }
          }
        }
  
        for (var i = 0; i < $navCell.length; i++) {
          if ($navCell[i].classList.contains('bundlevarimg_' + swatchprodid)) {
          var $alt = $($navCell[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $navContainer.append($navCell[i]);
            }
          }
        }
    });
  }
    
    //initiate flickity function
    initProductSlider($isShow);
    initNavSlider();
  }, 1);
}

initNavSlider = () =>{
  $('.selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;
 
  if ($(window).width() > 481) {
    if ($cellLength > 7) {
      $('.selectedNav').flickity($_flickityObj);
      $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 8) {
      $('.selectedNav').flickity($_flickityObj);
      $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.selectedNav').addClass('showthumbnailimg');
  }
}

initProductSlider = (isShow) =>{
  if (isShow) {

    var obj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true};

    $imgContainer.flickity(obj);

    // Flickity instance
    var flkty = $imgContainer.data('flickity');
    // elements
    var $cellButtonGroup = $('.selectedNav');
    var $cellButtons = $cellButtonGroup.find('.navCell');
 
    // update selected cellButtons
    $imgContainer.on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
      if ($(this).find('.is-selected').find('video').length > 0) {
        $(this).find('.is-selected').find('video')[0].play();
      }
    });
 
    // select cell on button click
    $cellButtonGroup.on( 'click', '.navCell', function() {
      var index = $(this).index();
      $imgContainer.flickity( 'select', index );
    });
  }
  // previous
    $('.button--previous').on( 'click', function() {
      $imgContainer.flickity('previous');
    });
  // next
    $('.button--next').on( 'click', function() {
      $imgContainer.flickity('next');
    });
}

destroyProductSlider = () =>{
  $('.product-slider-pdp').flickity();
  $('.product-slider-pdp').flickity('destroy');
}

destroyNavSlider = () =>{
  $('.selectedNav').flickity();
  $('.selectedNav').flickity('destroy');
}

//swap variant image - end

//swap variant image quick view - start
var $imgContainerQV;
var $childArrayElementQV;
var $navContainerQV;
var $navCellQV;

onloadGetProductImgArrayQV = ($imgContainerQV,$childArrayElementQV) =>{
  var $bundleColor = '';
  var $selectedColor = $('.side-panel.product-drawer .variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
  var $prodTitle = $('.side-panel.product-drawer .product-title').attr('data-title').toLowerCase();
  if ($(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
      bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
    });
    bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
    $bundleColor = bundlecolor;
  }
  if ($(".side-panel.product-drawer .prod-bundle-select").length > 1) {
    $selectedColor = $prodTitle;
  }
 
  // Destroy slider
  $imgContainerQV.flickity();
  $imgContainerQV.flickity('destroy');
  $navContainerQV.flickity();
  $navContainerQV.flickity('destroy');
 
  // remove all product image
  $imgContainerQV.children().remove();
  $navContainerQV.children().remove();
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElementQV.length; i++) {
    var $thisAltText = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
    if ($childArrayElementQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $imgContainerQV.append($childArrayElementQV[i]);
      $isShow = true;
    }
    }
  }

  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCellQV.length; i++) {
    var $thisAltText = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
    if ($navCellQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $navContainerQV.append($navCellQV[i]);
      $isShow = true;
    }
    }
  }

  $(".side-panel .swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchchild = $(this).val().toLowerCase();

      for (var i = 0; i < $childArrayElementQV.length; i++) {
        if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
            $imgContainerQV.append($childArrayElementQV[i]);
            $isShow = true;
            }
          }
        }
      }

      for (var i = 0; i < $navCellQV.length; i++) {
        if ($navCellQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
            $navContainerQV.append($navCellQV[i]);
            $isShow = true;
            }
          }
        }
      }
  });
  
  //initiate flickity function
  var obj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true};

  $imgContainerQV.flickity(obj);

  // Flickity instance
  var flkty = $imgContainerQV.data('flickity');
  // elements
  var $cellButtonGroup = $('.side-panel .selectedNav');
  var $cellButtons = $cellButtonGroup.find('.navCell');

  // update selected cellButtons
  $imgContainerQV.on( 'select.flickity', function() {
    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');
    if ($(this).find('.is-selected').find('video').length > 0) {
      $(this).find('.is-selected').find('video')[0].play();
    }
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.navCell', function() {
    var index = $(this).index();
    $imgContainerQV.flickity( 'select', index );
  });

  $('.side-panel .selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.side-panel .navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;

  if ($(window).width() > 481) {
    if ($cellLength > 5) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 8) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.side-panel .selectedNav').addClass('showthumbnailimg');
  }

}

variantImageSwapqv = (color, bundle) =>{
setTimeout(() => {
  var $isShow = false;
  var $bundleColor = '';
  if (bundle) {
    var $selectedColor = $(".side-panel .swatch_options.bundle-child-swatch input:checked").first().val().toLowerCase();
  }else{
    var $selectedColor = color.toLowerCase();
  }
  if ($(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
      bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
    });
    bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
    $bundleColor = bundlecolor;
  }
  var $prodTitle = $('.side-panel.product-drawer .product-title').attr('data-title').toLowerCase();

  // Destroy slider
  $imgContainerQV.flickity();
  $imgContainerQV.flickity('destroy');
  $navContainerQV.flickity();
  $navContainerQV.flickity('destroy');

  // remove all product image
  $imgContainerQV.children().remove();
  $navContainerQV.children().remove();
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElementQV.length; i++) {
    var $thisAltText = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
    if ($childArrayElementQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $imgContainerQV.append($childArrayElementQV[i]);
      $isShow = true;
    }
    }
  }

  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCellQV.length; i++) {
    var $thisAltText = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
    if ($navCellQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $navContainerQV.append($navCellQV[i]);
    }
    }
  }

  if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
  $(".side-panel .swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchchild = $(this).val().toLowerCase();

      for (var i = 0; i < $childArrayElementQV.length; i++) {
        if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            console.log($childArrayElementQV[i]);
            $imgContainerQV.append($childArrayElementQV[i]);
          }
        }
      }

      for (var i = 0; i < $navCellQV.length; i++) {
        if ($navCellQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            $navContainerQV.append($navCellQV[i]);
          }
        }
      }
  });
}else{

  $(".side-panel .prod-bundle-select .swatch_options.bundle-child-swatch .swatchbundlecol input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchchild = $(this).val().toLowerCase();
    var swatchprodid = $(this).attr('data-product-id');

      for (var i = 0; i < $childArrayElementQV.length; i++) {
        if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + swatchprodid)) {
        var $alt = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            $imgContainerQV.append($childArrayElementQV[i]);
          }
        }
      }

      for (var i = 0; i < $navCellQV.length; i++) {
        if ($navCellQV[i].classList.contains('bundlevarimg_' + swatchprodid)) {
        var $alt = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            $navContainerQV.append($navCellQV[i]);
          }
        }
      }
  });
}
  
  //initiate flickity function
  var obj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true};

  $imgContainerQV.flickity(obj);

  // Flickity instance
  var flkty = $imgContainerQV.data('flickity');
  // elements
  var $cellButtonGroup = $('.side-panel .selectedNav');
  var $cellButtons = $cellButtonGroup.find('.navCell');

  // update selected cellButtons
  $imgContainerQV.on( 'select.flickity', function() {
    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');
    if ($(this).find('.is-selected').find('video').length > 0) {
      $(this).find('.is-selected').find('video')[0].play();
    }
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.navCell', function() {
    var index = $(this).index();
    $imgContainerQV.flickity( 'select', index );
  });

  $('.side-panel .selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.side-panel .navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;

  if ($(window).width() > 481) {
    if ($cellLength > 5) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 4) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.side-panel .selectedNav').addClass('showthumbnailimg');
  }

}, 1);

}
//swap variant image quick view - end

openclosesearchmobile = (page_title) => {
  var $headerSearchMobile = $('.header-search-mobile');
  var $img = $('.header-search-wrap.header-search-mob-icon .svg-search');
  var $svgpath = $('.header-search-wrap.header-search-mob-icon .svg-search path');
  var $greenIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-green');
  var $searchIcon = $('.header-search-wrap.header-search-mob-icon .search-icon');
  var $searchIconColor = $('.header-search-wrap.header-search-mobile .search-icon .jsc-colour-page');

  var $searchInnerIcon = $('.search-icon .cls-1.jsc-colour-page');
  var $headerSearchMobile = $('.header-search-mobile');

  var screenWidth = window.innerWidth;
  var $mobileToggleWrapper = $('.mobile-toggle-wrapper.active');
  var color_page = false;

  if ($mobileToggleWrapper.length > 0) {
    var mobileToggleWrapperIsOpen = true;
  } else {
    var mobileToggleWrapperIsOpen = false;
  }
  
  if (page_title.includes("Addresses") || page_title.includes("Terms of Service") || page_title.includes("Privacy Policy")) {
    // var $img = $('.header-search-wrap.header-search-mob-icon .svg-search.jsc-close-white');
    var color_page = true;
  }
  $headerSearchMobile.toggle();

  if ($headerSearchMobile.is(':visible')) {
    if(color_page){
      $img.removeClass('hide');
      $searchIcon.hide();
    }else{
      $img.removeClass('hide');
      $searchIcon.hide();
    }
  } else {
    if(color_page){
      $img.addClass('hide');
      $searchIcon.show();
    }else{
      $img.addClass('hide');
      $searchIcon.show();
    }
  }
}

carouselHeight = () =>{
  $('.featured-collection-carousel');
}

//Start: grid height
updateGridHeight = () => {
  $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-title').css("height","auto");
  $('.featured-collection-carousel').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    $(this).find('.carousel__slide').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
    });
    $this.find('.carousel__slide').find('.product-card-title').css("height", $maxHeight + "px");
    $this.find('.carousel__slide').find('.product-card-info').css("height", $maxprodInfo + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-title').removeAttr("style");
    $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-info').removeAttr("style");

    setTimeout(function(){
      $('.featured-collection-carousel').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        $(this).find('.carousel__slide').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
        });
        $this.find('.carousel__slide').find('.product-card-title').css("height", $maxHeight + "px");
        $this.find('.carousel__slide').find('.product-card-info').css("height", $maxprodInfo + "px");
      });
    },1000);

    }

  });

}
updateGridHeightcollection = () => {
  $('.collection-container').find('.product-card').find('.product-card-title').css("height","auto");
  $('.collection-container').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    $(this).find('.product-card').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
    });
    $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.collection-container').find('.product-card').find('.product-card-title').removeAttr("style");

    setTimeout(function(){
      $('.collection-container').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        $(this).find('.product-card').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
        });
        $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
      });
    },1000);
    }

  });

}
updateGridHeightrecommendation = () => {
  $('.product-recommendations').find('.product-card').find('.product-card-title').css("height","auto");
  $('.product-recommendations').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    $(this).find('.product-card').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
    });
    $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.product-recommendations').find('.product-card').find('.product-card-title').removeAttr("style");

    setTimeout(function(){
      $('.product-recommendations').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        $(this).find('.product-card').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
        });
        $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
      });
    },1000);
  }

  });

}
//End: grid height

openMenuColor = () => {
  setTimeout(function(){
    $("#mobile-menu").addClass("menu-color");
  },500);
}

closeMenuColor = () =>{
  $("#mobile-menu").removeClass("menu-color");

}

//start: open mega menu from featured collection section
jscOpenMenu = (e, title, redirect, collectionURL) => {
  var $menuDrawer = $('.mobile-toggle-wrapper');

  var found = false;

  $menuDrawer.find('.jsc-link-container').each(function() {
    var $thisTitle = $(this).attr('data-title');

    if ($thisTitle == title && redirect == 'false') {
      // console.log(title, 'open this menu nav');
      $menuDrawer.addClass('active').attr('open', '');
      $('body').addClass('overflow-hidden');
      $(this).addClass('menu-opening').attr('open', '');
      $(this).addClass('submenu-open');
      $(this).parents('.mobile-menu-drawer').addClass('menu-color');
      $('#header').css("background","var(--hamburger-active-color)");
      $('#mobile-menu').css("background","var(--hamburger-active-color)");
      $('.jsc-account-menu').css("background","var(--hamburger-active-color)");
      found = true;
    }
  });

  if (!found) {
    if (redirect == 'true'){
      window.location.href = collectionURL;
    }else{
      $('a[title="' + title + '"]').each(function() {
        window.location.href = $(this).attr('href');
        return false;
      });
    }
  }
}
//end: open mega menu from featured collection section

//start: featured collection onload
// updateMobileImage = () => {
//   //start: to replace mobile image
//   if ($(window).width() < 481) {
//     $('.jsc-feat-coll-image').each(function(){
      
//       var $this_image = $(this).attr('data-mobile-image');
//       if ($this_image) {
//         $(this).find('img').attr('srcset',$this_image);
//         $(this).find('img').attr('src',$this_image);
//         if ($('.jsc-fc-slider-carousel').length == 0) {
//           $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//             'position': 'relative',
//             'display': 'none'
//           });
    
//           $('.featured-collection-list--inner').css({
//             'position': 'absolute',
//             'top': '0px'
//           });
    
//           $('.featured-collection-list--bg').css('position', 'relative');
//         }
//       }
//       $(this).find('img.feat-list-desk').remove();
//       setTimeout(function () {
//         $('.feat-list-mob').removeClass('feat-list-mob');
//         $('.feat-list-desk').removeClass('feat-list-desk');
//         if ($('.jsc-fc-slider-carousel').length > 0) {
//           $('.jsc-feat-coll-image').removeClass('hide');
//         }
//       }, 10);
//     });
//   }else{
//     $('.jsc-feat-coll-image').each(function(){

//       var $this_image = $(this).attr('data-desk-image');
//       if ($this_image) {
//         $(this).find('img').attr('srcset',$this_image);
//         $(this).find('img').attr('src',$this_image);
//         if ($('.jsc-fc-slider-carousel').length == 0) {
//           $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//             'position': 'absolute',
//             'display': 'unset'
//           });

//           $('.featured-collection-list--inner').css({
//             'position': 'relative',
//             'top': '0px'
//           }); 

//           $('.featured-collection-list--bg').css('position', 'absolute');
//         }
//       }
//       $(this).find('img.feat-list-mob').remove();
//       setTimeout(function () {
//         $('.feat-list-mob').removeClass('feat-list-mob');
//         $('.feat-list-desk').removeClass('feat-list-desk');
//         if ($('.jsc-fc-slider-carousel').length > 0) {
//           $('.jsc-feat-coll-image').removeClass('hide');
//         }
//       }, 10);
//     });
//   }
//   var prevWidth = window.innerWidth;
//   $(window).resize(function(){
//     var width = window.innerWidth;
//     if (width !== prevWidth) {
//     if ($(window).width() < 481) {
//       $('.jsc-feat-coll-image').each(function(){
        
//         var $this_image = $(this).attr('data-mobile-image');
//         if ($this_image) {
//           $(this).find('img').attr('srcset',$this_image);
//           $(this).find('img').attr('src',$this_image);
//           if ($('.jsc-fc-slider-carousel').length == 0) {
//             $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//               'position': 'relative',
//               'display': 'none'
//             });
//             $('.featured-collection-list--inner').css({
//               'position': 'absolute',
//               'top': '0px'
//             });
//             $('.featured-collection-list--bg').css('position', 'relative');
//           }
//         }
//       });
//     }else{
//       $('.jsc-feat-coll-image').each(function(){
        
//         var $this_image = $(this).attr('data-desk-image');
//         if ($this_image) {
//           $(this).find('img').attr('srcset',$this_image);
//           $(this).find('img').attr('src',$this_image);
//             if ($('.jsc-fc-slider-carousel').length == 0) {
//             $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//               'position': 'absolute',
//               'display': 'unset'
//             });

//             $('.featured-collection-list--inner').css({
//               'position': 'relative',
//               'top': '0px'
//             }); 

//             $('.featured-collection-list--bg').css('position', 'absolute');
//           }
//         }
//       });
//     }
//   }
//   });
//   //end: to replace mobile image
// }
//end: featured collection onload

//Start: store link list
onloadStoreLink = () =>{ 
  var storeLinkSelected = sessionStorage.getItem("storeLink"); 
  if (storeLinkSelected == 'Global') { 
    $('.store_link_selected .everett-light-r').text('Global'); 
    $('.store_active').removeClass('store_active'); 
    $('.global_selected').addClass('store_active');
    $('.img_store_flag').attr('src' , 'https://cdn.shopify.com/s/files/1/0716/6912/1303/files/global.png?v=1698136264'); 
  } 
  if (location.href.includes('?global')) {
    sessionStorage.setItem("storeLink",  'Global');
    $('.store_link_selected .everett-light-r').text('Global'); 
    $('.store_active').removeClass('store_active'); 
    $('.global_selected').addClass('store_active');
    $('.img_store_flag').attr('src' , 'https://cdn.shopify.com/s/files/1/0716/6912/1303/files/global.png?v=1698136264');
  }
} 
onClickStoreLink = (evt) =>{ 
  sessionStorage.setItem("storeLink",  $(evt).attr('data-store')); 
  console.log($(evt).attr('data-href')); 
  window.location.href = $(evt).attr('data-href'); 
}
opencloseStore = (evt) =>{ 
  $(evt).siblings('.shopLinkList').toggle();
  $('[onclick="opencloseCurrency(this);"]').siblings('.currencyList').hide();
}
//end: store link list

//Start: currency list
opencloseCurrency = (evt) =>{ 
  $(evt).siblings('.currencyList').toggle();
  $('[onclick="opencloseStore(this);"]').siblings('.shopLinkList').hide();
}
changeCurrency = (evt) =>{ 
  $(evt).parents('.currencyList').siblings('select').val($(evt).attr('data-value')).change();
  setTimeout(function () {
    $(evt).parents('form').submit();
  }, 10);
}
//end: currency list

//Start: vip disabled ATC
swapvipcheck = (disabled,firstLoad) =>{ 
  setTimeout(function () {
  $('.product-grid-container .product-information--inner').each(function () {
    var thisprodInfo = $(this);
    var vipVar = false;
    var bishide = false;
    console.log('swapvipcheck');
    if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
      //console.log('sold out');
    }else{
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
    //For add to cart sticky
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
    }
    thisprodInfo.find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      var datavip = $(this).attr('data-vip');
      var dataavai = $(this).attr('data-var-avail');
      var showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
      if (datavarid == thisprodInfo.find(".variant-selected-form").val() && showcomingsoonwheninstock == 'true') {
        var dataLaunchDateTime = $(this).attr('data-launch-time-date');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        if(dataLaunchDateTime != '' && dataLaunchDateTime){
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
        }else{
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        }
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
      }else{
        //check each if the variant is VIP if VIP check whether VIP customer is login.
        if (datavarid == thisprodInfo.find(".variant-selected-form").val() && datavip) {
          if (datavip == 'true') {
            vipVar = true;
            if ($("#vipCustomer").length >= 1 && dataavai == 'true') {
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
              //For add to cart sticky
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
            }else{
              var dataLaunchDateTime = $(this).attr('data-launch-time-date');
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
              thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
              //For add to cart sticky
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
            }
          }
        }
        //Hide/Show PWP Section
        var dataPWP = $(this).attr('data-pwp-show');
        if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
          if (dataPWP == 'true') {
            $("#jsc-pwp-section").show();
          }else{
            $("#jsc-pwp-section").hide();
          }
        }

        var databishide = $(this).attr('data-bis-hide');
        if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
          if (databishide == 'true') {
            bishide = true;
          }
        }
        if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
          bishide = true;
        }
      }
    });
    if (vipVar == false) {
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
      //For add to cart sticky
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');

      if (firstLoad == true) {
        if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out')) {
          thisprodInfo.find(".swym-bid-pdp").show();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").show();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          if (bishide) {
            thisprodInfo.find(".swym-bid-pdp").hide();
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
            thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
            //For add to cart sticky
            $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
            $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          }
        }else{
          thisprodInfo.find(".swym-bid-pdp").hide();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          enablePWPATC();
        }
      }else{
        if (disabled) {
          thisprodInfo.find(".swym-bid-pdp").show();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").hide();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").show();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").hide();
          if (bishide) {
            thisprodInfo.find(".swym-bid-pdp").hide();
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
            thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
            //For add to cart sticky
            $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
            $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          }
        }else{
          thisprodInfo.find(".swym-bid-pdp").hide();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          enablePWPATC();
        }
      }
    }else{
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      thisprodInfo.find(".swym-bid-pdp").hide();
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
      thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
      //For add to cart sticky
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
      $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
      enablePWPATC();
    }
  });
  }, 10);
}

swapvipcheckGrid = (disabled) =>{ 
  $('.side-panel-inner .product-information--inner').each(function () {
    var thisprodInfo = $(this);
    var vipVar = false;
    var bishide = false;
    console.log('swapvipcheckGrid');
    if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
      //console.log('sold out');
    }else{
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
    }
    thisprodInfo.find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      var datavip = $(this).attr('data-vip');
      var dataavai = $(this).attr('data-var-avail');
      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
      //check each if the variant is VIP if VIP check whether VIP customer is login.
      if (datavarid == thisprodInfo.find(".variant-selected-form").val() && datavip) {
        if (datavip == 'true') {
          vipVar = true;
          if ($("#vipCustomer").length >= 1 && dataavai == 'true') {
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
          }else{
            console.log("here22", dataLaunchDateTime);
            console.log(thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)"));
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
          }
        }
      }

      var databishide = $(this).attr('data-bis-hide');
      if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
        if (databishide == 'true') {
          bishide = true;
        }
      }
      if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
        bishide = true;
      }
    });
    if (vipVar == false) {
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
      if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
        thisprodInfo.find(".swym-bid-qv").show();
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hide();
        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").hide();
        if (bishide) {
          thisprodInfo.find(".swym-bid-qv").hide();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
        }
      }else{
        thisprodInfo.find(".swym-bid-qv").hide();
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
        enablePWPATC();
      }
    }else{
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      thisprodInfo.find(".swym-bid-qv").hide();
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
      thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
      enablePWPATC();
    }
    $('.var-limit-list').each(function(){
      var varID = $(this).val();
      if (varID == thisprodInfo.find(".variant-selected-form").val()) {
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
      }
    });
    $('.var-limit-product-list').each(function(){
      var varID = $(this).val();
      if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
      }
    });
  });
}
//end: vip disabled ATC

//Start: Open BIS PDP
openBIS = (evt) =>{ 
  $('button.swym-add-to-watchlist').click();
}
//end: Open BIS PDP

//Start: sort list
opencloseSort = (evt) =>{
  var screenWidth = window.innerWidth;
  if (screenWidth <= 768) {
    $(evt).toggleClass('sort-button-open');
    $(evt).parent().find('.currencyList').toggle().toggleClass('sortList');
  } else {
    $(evt).siblings('.currencyList').toggle();
  }
}
changeSort = (evt) =>{ 
  $(evt).parents('.currencyList').siblings('select').val($(evt).attr('data-value')).change();
  setTimeout(function () {
    $(evt).parents('form').submit();
  }, 10);
}
//end: sort list

handleSortResize = () => {
  $('.currencyList').removeClass('sortList').hide(); // Hide to ensure it does not remain visible
  $('.sort-button-open').removeClass('sort-button-open');
}

var prevWidth = window.innerWidth;
$( window ).resize(function() {
  var width = window.innerWidth;
  if (width !== prevWidth) {
  handleSortResize();
}
});

// Start - CartJS Function
// cartJSEvent = () => {
//   $(document).on('cart.requestStarted', function(event, cart) {
//     var $html = `<div class="jsc-page-loading">
//                   <div class="jsc-spinner-container">
//                     <div class="jsc-spinner"></div>
//                   </div>
//                 </div>`;
//     $('body').prepend($html);
//   });
//   $(document).on('cart.requestComplete', function(event, cart) {
//     if ($('#Cart-Drawer').length > 0) {
//       document.dispatchEvent(new CustomEvent('customcart:refresh'));
//     }
//     if ($('.main-cart-section').length > 0) {
//       document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
//     }
//   });
// }

cartJSAddQuery = (vid, qty, prop, opendrawer) => {
// Cart js add item, success callback, error callback

CartJS.addItem(vid, qty, prop,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      console.log('Added item to cart');
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSAddSQuery = (jsonObj, opendrawer) => {
  // Cart js add item, success callback, error callback
  
  CartJS.addItems(jsonObj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
                
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });
}

cartJSUpdateQuery = (vid, qty, prop, isOpenDrawer) =>{

  CartJS.updateItemById(vid, qty, prop,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      console.log('Updated item in cart');

    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
// End - CartJS Function
// Start - Master Promo Function
masterPromo = () =>{
  addGift();
  removeGift();
  updateGift();
  removepacketgiftOnload();
  enablePWPATC();
  removeGiftAndMainItemLineItemProperties();
  removeMainProdLineItemProperties();
  updateGiftWrap();
}
// End - Master Promo Function
// Start - Packet Gift Function
removepacketgift = () =>{
  sessionStorage.setItem("redPacket", "Remove");
}
removepacketgiftOnload = () =>{
  if ($('.disabledoptout').length > 0) {
    sessionStorage.removeItem('redPacket');
  }
  var removeRED = sessionStorage.getItem("redPacket");
  if ($('.jsc-packet-gift').length > 0 && removeRED == 'Remove') {
    $('.jsc-packet-gift').each(function(){
      var varID = $(this).val();
      CartJS.updateItemById(varID, 0);
    });
  }
}
// End - Packet Gift Function
// Start - Gift Function
addGift = () =>{
  if ($('.jsc-add-gift').length > 0) {
    $('.jsc-add-gift').each(function(){
      var varID = $(this).val();
      var varProp = $(this).attr("data-prop");
      var varqty = parseInt($(this).attr('data-quantity'));
      var $obj = {};
      $obj['_Cart_GWP'] = 'Free Gift';
      if (varProp && varProp == 'packet') {
        var removeRED = sessionStorage.getItem("redPacket");
        $obj['_Cart_GWP_packet'] = 'True';
        if (removeRED != 'Remove') {
          if (varqty > 1) {
            cartJSAddQuery(varID, varqty, $obj);
          }else{
          cartJSAddQuery(varID, 1, $obj);
          }
        }
      }else if (varProp && varProp == 'collab') {
        var removeRED = sessionStorage.getItem("collab");
        $obj['_Cart_GWP_Collab'] = $(this).attr("data-colab");
        if (varqty > 1) {
          cartJSAddQuery(varID, varqty, $obj);
        }else{
        cartJSAddQuery(varID, 1, $obj);
        }
      }else{
        if (varqty > 1) {
          cartJSAddQuery(varID, varqty, $obj);
        }else{
        cartJSAddQuery(varID, 1, $obj);
        }
      }
    });
  }
}
removeGift = () =>{
  if ($('.jsc-remove-gift').length > 0) {
    var jsonObj = {};
    $('.checkout-button').attr('disabled', true);
    $('.jsc-remove-gift').each(function(){
      var varID = $(this).val();
      //CartJS.updateItemById(varID, 0);
      jsonObj[varID] = 0;
    });
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}
updateGift = () =>{
  if ($('.jsc-update-gift').length > 0) {
    $('.checkout-button').attr('disabled', true);
    $('.jsc-update-gift').each(function(){
      var varID = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      CartJS.updateItemById(varID, QTY);
    });
  }
}
// End - Gift Function
// Start - GWP Popup Function
gwpPopupATCfirstload = (evt) =>{
  var $obj = {};
  $obj['_Cart_GWP'] = 'Free Gift';
  $obj['_Cart_GWP_popup'] = 'true';
  var varID = $('.jsc-gwp-cart-prod-ele').attr("data-id");
  var removeGWPpopup = sessionStorage.getItem("gwppopup");
  var $checkboxInput = $('.jsc-gwp-cart-checkbox').find('input');

  if ($checkboxInput.prop('checked')) {
  } else if (removeGWPpopup != 'remove' && varID) {
    cartJSAddQuery(varID, 1, $obj);
    sessionStorage.setItem("gwppopup", "added");
  }
}
gwpPopupATC = (evt) =>{
  var $obj = {};
  $obj['_Cart_GWP'] = 'Free Gift';
  $obj['_Cart_GWP_popup'] = 'true';
  var varID = $(evt).attr("data-id");
  console.log("evt", evt);
  var $checkboxInput = $('.jsc-gwp-cart-checkbox').find('input');

  if ($checkboxInput.prop('checked')) {
    cartJSAddQuery(varID, 1, $obj);
    sessionStorage.setItem("gwppopup", "added");
  } else {
    gwpPopupRemove(varID);
    sessionStorage.setItem("gwppopup", "remove");
  }
}
gwpPopupRemove = (varID) =>{
  var jsonObj = {};
    //CartJS.updateItemById(varID, 0);
    jsonObj[varID] = 0;
  CartJS.updateItemQuantitiesById(jsonObj);
}

// End - Gift Function
// Start - Packet Gift Function
removecollabgift = () =>{
  sessionStorage.setItem("collab", "Remove");
}
removecollabgiftOnload = () =>{
  var removeRED = sessionStorage.getItem("collab");
  if ($('.jsc-collab-gift').length > 0 && removeRED == 'Remove') {
    $('.jsc-collab-gift').each(function(){
      var varID = $(this).val();
      CartJS.updateItemById(varID, 0);
    });
  }
}
// End - Packet Gift Function
// Start - PWP Function
enablePWPATC = () =>{
  $('.pwp-child-form').each(function(){
    var childprodID = $(this).attr('data-product-id');
    var enablePWP = false;
    $('.jsc-pwp-enable').each(function(){
      var checkedprodID = $(this).val();
      if (childprodID == checkedprodID) {
        enablePWP = true;
      }
    });
    if (enablePWP == false) {
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").addClass('jsc-sold-out-styling');
      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
      $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
      if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
      }else{
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Coming Soon');
      }      
    }else{
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeAttr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeClass('jsc-sold-out-styling');
      $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
      $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeAttr('disabled', 'disabled');
      if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
      }else{
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Add To Bag');
      } 
    }
    $('.jsc-pwp-limit').each(function(){
      var checkedprodID = $(this).val();
      if (checkedprodID == childprodID) {
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
        if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
          $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        }else{
          $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Coming Soon');
        }
      }
    });
  });
}
// End - PWP Function
// End - PDP accordion
closeOtherAccordion = (evt) =>{
  $(evt).parents('.product-information--inner').find('.product__accordion').each(function(){
    if ( $(this).is(evt) ) {
    }else{
      $(this).find('details').removeAttr("open");
    }
  });
}
// End - PDP accordion
// Start - Bundle Product Page Function
onloadchecksoldoutBundle = () =>{
  $('.bundle-child-swatch').find('.jsc-sold-out').removeClass('soldout-active');
  $('.bundle-child-swatch').find('input.soldout:checked').each(function(){
    $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').addClass('soldout-active');
    var comingsoon = $(this).attr('coming-soon-bundle');
    if (comingsoon) {
      $(this).parents('.bundle-child-swatch').each(function() {
        if ($(this).find('.label-coming-soon').length === 0) {
          $(this).find('.jsc-sold-out').text('Coming Soon');
          $(this).find('.jsc-sold-out').css('background', '#FF8600');
        }else{
          $(evt).parents('.bundle-child-swatch').find('.jsc-sold-out').removeClass('soldout-active');
        }
      })
    }else{
      $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').text('Sold Out');
      $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').css('background','#939393');
    }
  });
  $('.bundle-child-swatch').find(".jsc-var-bundle-label").hide();
  $('.bundle-child-swatch').each(function(){

    var vartitle = '';
    $(this).find('input:checked').each(function () {
      vartitle = vartitle + $(this).attr('data-value') + ' / ';
    });
    vartitle = vartitle.slice(0, -3);

    var childID = '';
    $(this).find('.bundlevarID').each(function () {
      if ($(this).attr('data-var-title') == vartitle) {
        childID = $(this).attr('data-var-id');
      }
    });

    $(this).find(".jsc-var-bundle-label").each(function () {
      var labelvarid = $(this).attr('data-label-id');
      //check each of variant that is equal to variant id then show
      if (childID == labelvarid) {
        $(this).show();
      }
    });

  });
  /*
  $('.bundle-child-swatch').find('input:checked').each(function(){
    var datavarid = $(this).attr('data-id');
    $(this).parents('.bundle-child-swatch').find(".jsc-var-bundle-label").each(function () {
      var labelvarid = $(this).attr('data-label-id');
      //check each of variant that is equal to variant id then show
      if (datavarid == labelvarid) {
        $(this).show();
      }
    });
  });
  */
  if ( $('.swatch_options.bundle-child-swatch input:not(.soldout):checked').length == $('.swatch_options.bundle-child-swatch input:checked').length ) { 
    $('.jsc-set-incomplete').removeClass('error-bundle-active');
    $('.bundle-atc-form').removeClass('disabled');
    $('.bundle-atc-form').removeClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Add To Bag');
    $('.bundle-atc-form').attr('onclick','atcBundle(this)');
  }else{
    $('.jsc-set-incomplete').addClass('error-bundle-active');
    $('.bundle-atc-form').addClass('disabled');
    $('.bundle-atc-form').addClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Sold Out');
    $('.bundle-atc-form').attr('onclick','');
  }
  if ($('.bundle-select-prod-main').length > 0) {
    $('.bundle-atc-form').attr('onclick', '');
    $('.jsc-set-incomplete').removeClass('error-bundle-active');
    $('.bundle-atc-form').removeClass('disabled');
    $('.bundle-atc-form').removeClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Add To Bag');
  }
}
onloadselectcolbundle = () =>{
  var selectcol = $('.selectbundlecol').val();
  $(".bundle-child-swatch").find('.jsc-each-swatch').each(function () {
    var checkcol = $(this).find('input').val();
    if (checkcol == selectcol) {
      $(this).find('label').click()
    }
  });
}
swapvarBundle = (evt) =>{
  
  const $bundleSwatch = $(evt).parents('.bundle-child-swatch');
  const $swatch = $(evt).parents('.swatch');
  const $eachSwatch = $(evt).parents('.jsc-each-swatch');

  // Reset sold-out/coming-soon states immediately
  $bundleSwatch.find('.jsc-sold-out').removeClass('soldout-active coming-soon-active');

  // Update selected swatch label
  $swatch.find('.jsc-selected-swatch').text($eachSwatch.find('input').val());

  setTimeout(function () {
    const $soldOutLabel = $bundleSwatch.find('.jsc-sold-out');

    // Reset again to ensure clean state
    $soldOutLabel.removeClass('soldout-active coming-soon-active');

    // Handle each soldout input
    $bundleSwatch.find('input.soldout:checked').each(function () {
      const $input = $(this);
      const $parentSwatch = $input.parents('.bundle-child-swatch');
      const comingSoon = $input.attr('coming-soon-bundle');

      $parentSwatch.find('.jsc-sold-out').addClass('soldout-active');

      if (comingSoon) {
        $parentSwatch.each(function () {
          const $this = $(this);
          if ($this.find('.label-coming-soon').length === 0) {
            $this.find('.jsc-sold-out').text('Coming Soon').css('background', '#FF8600');
          } else {
            $this.find('.jsc-sold-out').removeClass('soldout-active');
          }
        });
      } else {
        $parentSwatch.find('.jsc-sold-out').text('Sold Out').css('background', '#939393');
      }
    });

    // Update variant bundle label visibility
    $bundleSwatch.find(".jsc-var-bundle-label").hide();
    $bundleSwatch.each(function () {
      const $this = $(this);
      let vartitle = '';

      $this.find('input:checked').each(function () {
        vartitle += $(this).attr('data-value') + ' / ';
      });

      vartitle = vartitle.slice(0, -3);

      let childID = '';
      $this.find('.bundlevarID').each(function () {
        const $var = $(this);
        if ($var.attr('data-var-title') === vartitle) {
          childID = $var.attr('data-var-id');
          if ($var.attr('data-available') === 'false') {
            const $parentSwatch = $var.parents('.bundle-child-swatch');
            $parentSwatch.find('.jsc-sold-out').addClass('soldout-active');

            const comingSoon = $var.attr('coming-soon-bundle');
            if (comingSoon) {
              $parentSwatch.each(function () {
                const $this = $(this);
                if ($this.find('.label-coming-soon').length === 0) {
                  $this.find('.jsc-sold-out')
                    .text('Coming Soon')
                    .css('background', '#FF8600')
                    .addClass('coming-soon-active');
                } else {
                  $this.find('.jsc-sold-out').removeClass('soldout-active');
                }
              });
            } else {
              $parentSwatch.find('.jsc-sold-out').text('Sold Out').css('background', '#939393');
            }
          }
        }
      });

      // Show the matching label
      $this.find(".jsc-var-bundle-label").each(function () {
        if ($(this).attr('data-label-id') === childID) {
          $(this).show();
        }
      });
    });

    // Calculate total bundle price and update UI
    let totalbundleprice = 0;
    $(evt).parents('.bundle-select-prod-main').find(".bundle-child-swatch").each(function () {
      const $this = $(this);
      let vartitle = '';

      $this.find('input:checked').each(function () {
        vartitle += $(this).attr('data-value') + ' / ';
      });

      vartitle = vartitle.slice(0, -3);

      var indeximg = $(evt).parents('.bundle-select-prod-main').find(".bundle-child-swatch").index(this);

      $this.find('.bundlevarID').each(function () {
        const $var = $(this);
        if ($var.attr('data-var-title') === vartitle) {
          totalbundleprice += parseInt($var.attr('data-var-price'), 10);
          const featimg = $var.attr('data-feat-img');

          // Widths you want in srcset
          var widths = [352, 832, 1200, 1920, 2000];

          // Build srcset by appending `&width=...` to featimg
          var srcset = widths.map(function(w) {
            return featimg + "&width=" + w + " " + w + "w";
          }).join(", ");

          $(evt).parents('.thb-product-detail').find('.product-single__media .bundle-img-list').each(function(index) {
            if (index === indeximg) {
              $(this).attr('src', featimg + "&width=2000"); // Update src to high-res
              $(this).attr('srcset', srcset); // Update srcset with different sizes
            }
          });
          $(evt).parents('.thb-product-detail').find('.navCell .bundle-img-list').each(function(index) {
            if (index === indeximg) {
              $(this).attr('src', featimg); // Update src to high-res
            }
          });

          $this.parents('.prod-bundle-select').find('.feature-img-bundle img').attr('src', featimg);
          $this.parents('.prod-bundle-select').find('.feature-img-bundle').show();
          $this.parents('.prod-bundle-select').find('.opt-wrap').addClass('opt-wrap-set');
        }
      });
    });

    // if (totalbundleprice > 0) {
    //   const format = window.theme.settings.money_with_currency_format || "${{amount}}";
    //   const currencyformattotalprice = formatMoney(totalbundleprice, format);
    //   const $amount = $(evt).parents('.product-information').find('.product-price-container .amount');
    //   $amount.empty().append(currencyformattotalprice);
    // }

    const $main = $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main');
    const $context = $main.length > 0 ? $main : $(document);

    const $allInputs = $context.find('.swatch_options.bundle-child-swatch input');
    const $checked = $allInputs.filter(':checked');
    const $checkedNotSoldOut = $checked.not('.soldout');
    const $comingSoon = $checked.filter('[coming-soon-bundle="true"]');

    const totalChecked = $checked.length;
    const totalNotSoldOut = $checkedNotSoldOut.length;

    const $bundleATC = $(evt).parents('.thb-product-detail').find('.bundle-atc-form');
    const $setIncomplete = $(evt).parents('.thb-product-detail').find('.jsc-set-incomplete');

    const allSelectedNotSoldOut = totalChecked === totalNotSoldOut;
    const allSelected = totalChecked === $allInputs.length;

    const isMain = $main.length > 0;
    const mainChildrenMatch = isMain &&
      $main.find('.bundle-child-swatch').length === $main.find('.prod-bundle-select').length;

    const isComplete = isMain ? allSelectedNotSoldOut && mainChildrenMatch : allSelectedNotSoldOut;

    const hasComingSoonFlag = $comingSoon.length > 0 || $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main .coming-soon-active').length > 0;
    const hasSoldOutFlag = $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main .soldout-active').length > 0;

    const prodMismatch = $(evt).parents('.thb-product-detail').find('.prod-bundle-select').length !== $(evt).parents('.thb-product-detail').find('.prod-bundle-select .bundle-prod-var').length;

    if (isComplete) {
      $setIncomplete.removeClass('error-bundle-active');
      $bundleATC.removeClass('disabled jsc-sold-out-styling')
        .text('Add To Bag')
        .attr('onclick', 'atcBundle(this)');
    } else if (hasComingSoonFlag) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Coming Soon')
        .attr('onclick', '');
    } else if (hasSoldOutFlag || !allSelectedNotSoldOut) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Sold Out')
        .attr('onclick', '');
    }

    if (hasSoldOutFlag) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Sold Out')
        .attr('onclick', '');
    }

    if (prodMismatch) {
      $bundleATC.attr('onclick', '');
    }

    console.log(
      totalNotSoldOut,
      totalChecked,
      $main.find('.bundle-child-swatch').length,
      $main.find('.prod-bundle-select').length
    );

    // Update main input label visibility
    $(evt).parents('.product-information').find('.bundle-child-swatch input:checked').each(function (index) {
      const childCol = $(this).attr('data-value');

      if (index === 0) {
        $('.bundle-main-input').each(function () {
          if ($(this).val() === childCol) {
            const mainid = $(this).attr('data-main-id');
            const $labelContainer = $(evt).parents('.product-information--inner');
            $labelContainer.find(".jsc-var-label").hide();
            $labelContainer.find(".jsc-var-label").each(function () {
              if ($(this).attr('data-label-id') === mainid) {
                $(this).show();
              }
            });
          }
        });
      }
    });

  }, 100);
}
swapColOverlay = () =>{
  setTimeout(function(){
    $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
      var productIndex = index + 1;
      var srcImg = $(this).attr('data-overlay');
      $(".jsc-img-overlay-list-" + productIndex).each(function () {
        $(this).attr('src', srcImg);
      });
    });
  }, 10);
}
atcBundle = (evt) => {
  var $productDetail = $(evt).closest('.thb-product-detail');
  var $mainContainer = $productDetail.find('.bundle-select-prod-main');
  var isBundleMain = $mainContainer.length > 0;

  var $targetContainer = isBundleMain ? $mainContainer : $productDetail;
  var $checkedInputs = $targetContainer.find('.swatch_options.bundle-child-swatch input:checked');
  var $checkedNotSoldOut = $checkedInputs.filter(':not(.soldout)');

  if ($checkedInputs.length === $checkedNotSoldOut.length) {
    console.log('enable atc bundle');

    var jsonObj = [];
    var bindID = '';
    var getmainid = '';

    $checkedNotSoldOut.each(function(index) {
      var $input = $(this);
      var childID = $input.data('id');
      var childCol = $input.data('value');
      bindID += `${childID}-${childCol}-`;

      if (index === 0) {
        $('.bundle-main-input').each(function() {
          if ($(this).val() === childCol) {
            getmainid = $(this).data('main-id');
          }
        });
      }
    });

    bindID = bindID.slice(0, -1); // remove trailing '-'

    if ($productDetail.find('.normalbundleopt').length > 0) {
      var $bundleVars = isBundleMain
        ? $mainContainer.find('.bundle-prod-var')
        : $productDetail.find('.bundle-prod-var');

      $($bundleVars.get().reverse()).each(function() {
        var $varGroup = $(this);
        var vartitle = $varGroup.find('input:not(.soldout):checked')
          .map(function() {
            return $(this).data('value');
          }).get().join(' / ');

        var childID = '';
        $varGroup.find('.bundlevarID').each(function() {
          if ($(this).data('var-title') === vartitle) {
            childID = $(this).data('var-id');
          }
        });

        jsonObj.push({
          id: childID,
          quantity: 1,
          properties: {}
        });
      });

    } else {
      $($checkedNotSoldOut.get().reverse()).each(function() {
        var $input = $(this);
        jsonObj.push({
          id: $input.data('id'),
          quantity: 1,
          properties: {
            '_Bind ID': bindID,
            '_Bundle Product': 'Child',
            _Bundle_Overlay: $input.data('overlay')
          }
        });
      });

      jsonObj.push({
        id: getmainid,
        quantity: 1,
        properties: {
          '_Bind ID': bindID,
          '_Bundle Product': 'Main'
        }
      });
    }

    cartJSAddSQuery(jsonObj);

  } else {
    // $('.jsc-set-incomplete').addClass('error-bundle-active');
    // setTimeout(() => $('.jsc-set-incomplete').removeClass('error-bundle-active'), 2500);
    console.log('disabled atc bundle');
  }
}
removeAllbundle = (keylist, giftWrapPrdBindID) =>{
  var keysplit = keylist.split(",");
  var jsonObj = {};
  for (i=0;i<keysplit.length;i++){
      jsonObj[keysplit[i]] = 0;
  }
  if($('.jsc-cart-item-giftwrap').length > 0) {
    $('.jsc-cart-item-giftwrap').each(function() {
      var giftWrapBindID = $(this).attr('giftwrap-bindid');
      var giftWrapVarID = $(this).attr('data-product-id');

      if (giftWrapBindID == giftWrapPrdBindID) {
        console.log("Exist");
        var selectedGiftWrapVarID = giftWrapVarID;
        jsonObj[selectedGiftWrapVarID] = 0;
        console.log("jsonObj", jsonObj);
        CartJS.updateItemQuantitiesById(jsonObj, {
          "success": function(data, textStatus, jqXHR) {
            console.log('Remove item - bundle', jqXHR);
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while updating item quantities:", errorThrown);
          }
        });
      }
    });
  }else{
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}
// End - Bundle Product Page Function
// Start - Laces Popup Function
openMaskPersonalize = (evt) =>{
  if ($(evt).parents('.product-information--inner').find('.popup-variant-img-laces').length > 0) {
    if ($(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').length <= 0) {
      $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap').first().addClass('color-active');
    }
    var shoescol = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
    var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val().toLowerCase();
    var comAlt = shoescol + '-' + lacescol;

    $(evt).parents('.product-information--inner').find('.jsc-imglaces').each(function(){
      var altImg = $(this).attr('data-alt');
      var scrImg = $(this).val();
      if (comAlt == altImg) {
        $(evt).parents('.product-information--inner').find('.popup-variant-img-laces').attr('src', scrImg);
      }
    });

    var selectedSize;
    var dataavai;
    $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
        selectedSize = $(this).attr('data-lacesize');
        dataavai = $(this).attr('data-var-avail');
      }
    });
    var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

    if (selectedSize) {
      $(evt).parents('.product-information--inner').find('.jsc-color-laces').text($('.jsc-col-var-wrap.color-active').find('input').val() + ' ');
      $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
        var varTitle = $(this).attr('data-vartitle');
        if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
          var varAvai = $(this).attr('data-avai');
          if (varAvai == 'true' && dataavai == 'true') {
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeAttr('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Add To Bag');
          }else{
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').attr('disabled','disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Sold Out');
          }
        }
      });

      var $getColor = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val();
      var $getSize = $(evt).parents('.product-information--inner').find('.variations .product-form__input--block input[type="radio"]:checked').val();
      var $productTitlecontainer = $('.jsc-main-variant');
      var $productTitle = $('.product_name').text();

      if ($(window).width() < 1025) {
        $productTitlecontainer.text('');
        $productTitlecontainer.children().remove();
        $productTitlecontainer.text($productTitle);
        $productTitlecontainer.append('<span class="jsc-color-size">'+ $getColor + ' (' + $getSize + ')' +'</span>');
      }else {
        $productTitlecontainer.text('');
        $productTitlecontainer.children().remove();
        $productTitlecontainer.text($productTitle);
        $productTitlecontainer.append('<span class="jsc-color-size">'+ $getColor + ' (' + $getSize + ')' +'</span>');
      }
    }

  }

  $(evt).parents('.product-information--inner').find('.jsc-question-popup-overlay').show();
  $('body').css("overflow", "hidden");
  $(evt).parents('.product-information--inner').find('.jsc-mask-popup').show();
  $('.header-section').addClass('headerindex');
  $('.announcement-bar-section').addClass('headerindex');
  $('.product-add-to-cart-sticky').addClass('headerindex');
  $('#smile-ui-container').addClass('headerindex');
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

closeMaskPersonalize = () =>{
  $('.jsc-question-popup-overlay').hide();
  $('body').css("overflow", "auto");
  $('.jsc-mask-popup').hide();
  $('.header-section').removeClass('headerindex');
  $('.announcement-bar-section').removeClass('headerindex');
  $('.product-add-to-cart-sticky').removeClass('headerindex');
  $('#smile-ui-container').addClass('headerindex');
}

selectvarColLaces = (evt) =>{
  var $this = $(evt);
  var $colorLabel = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap');
  $colorLabel.removeClass('color-active');
  $this.parent('.jsc-col-var-wrap').addClass('color-active');

  setTimeout(function(){
    $(evt).parents('.product-information--inner').find('.jsc-color-laces').text($(evt).parents('.color-active').find('input').val() + ' ');
    if ($(evt).parents('.product-information--inner').find('.popup-variant-img-laces').length > 0) {
      var shoescol = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
      var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val().toLowerCase();
      var comAlt = shoescol + '-' + lacescol;

      $(evt).parents('.product-information--inner').find('.jsc-imglaces').each(function(){
        var altImg = $(this).attr('data-alt');
        var scrImg = $(this).val();
        if (comAlt == altImg) {
          $(evt).parents('.product-information--inner').find('.popup-variant-img-laces').attr('src', scrImg);
        }
      });

      var selectedSize;
      var dataavai;
      $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
        var datavarid = $(this).attr('data-var-id');
        if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
          selectedSize = $(this).attr('data-lacesize');
          dataavai = $(this).attr('data-var-avail');
        }
      });
      var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

      if (selectedSize) {
        $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
          var varTitle = $(this).attr('data-vartitle');
          if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
            var varAvai = $(this).attr('data-avai');
            if (varAvai == 'true' && dataavai == 'true') {
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeAttr('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Add To Bag');
            }else{
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').attr('disabled','disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Sold Out');
            }
          }
        });
      }
    }

  }, 10);

}

addtocartlacespersonalize = (evt) =>{
  var selectedSize;
  $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
    var datavarid = $(this).attr('data-var-id');
    if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
      selectedSize = $(this).attr('data-lacesize');
      dataavai = $(this).attr('data-var-avail');
    }
  });
  var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

  if (selectedSize) {
    $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
      var varTitle = $(this).attr('data-vartitle');
      if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
        var varID = $(this).val();
        var $mainID = $(evt).parents('.product-information--inner').find(".variant-selected-form").val();
        var jsonObj = [];
        var item = {};
        item ["id"] = varID;
        item ["quantity"] = 1;
        item ["properties"] = {};
        jsonObj.push(item);
        var item = {};
        item ["id"] = $mainID;
        item ["quantity"] = 1;
        item ["properties"] = {};
        jsonObj.push(item);
        cartJSAddSQuery(jsonObj);
      }
    });
  }
}
// End - Laces Popup Function

// Start - Popup Section Function

showPopupSection = () => {
  var userOrderCount = $('.jsc-user-data').attr("data-order-count");
  var isShowBefore = sessionStorage.getItem("jsc-popup-section");
  if((userOrderCount == 0 || userOrderCount == '0') && (!isShowBefore)){
    setTimeout(() => {
      $('.jsc-popup-section').show(); 
      $('.jsc-popup-button').show();
    }, 3000);
  }

}

closePopupSection = () =>{
  $('.jsc-popup-section').hide();
  $('.jsc-popup-button').hide();
  sessionStorage.setItem("jsc-popup-section", "yes");
}
// End - Popup Section Function

getUserIPInfo = () => {
  var storeSG = false;
  var storeJP = false;
  var storePH = false;

  if (location.href.includes('.com')) {
    storeSG = true;
  } else if(location.href.includes('.jp')){
    storeJP = true;
  }else if(location.href.includes('.ph')){
    storePH = true;
  }

  $.get("https://ipinfo.io/json", function (response) {
    var userIPCountry = response.country;
    var shippingLineTextElement = $('.free-shipping--text .jsc-shipping-line');
    var shippingSpendTextElement = $('.free-shipping--text .jsc-spend-shipping-line');
    var frontShippingTextLocal = $('#jsc-front-shipping-text-local').val().trim();
    var backShippingTextLocal = $('#jsc-back-shipping-text-local').val().trim();
    var frontShippingTextInt = $('#jsc-front-shipping-text-int').val().trim();
    var backShippingTextInt = $('#jsc-back-shipping-text-int').val().trim();
    
    updateShippingText = (element, text) => {
      if (element.length) {
        element.text(text);
      }
    }
    if((userIPCountry == "SG" && StoreSG) || (userIPCountry == "JP" && storeJP) || (userIPCountry == "PH" && storePH)){
      updateShippingText(shippingLineTextElement, frontShippingTextLocal);
      updateShippingText(shippingSpendTextElement, backShippingTextLocal);

    }else{
      updateShippingText(shippingLineTextElement, frontShippingTextInt);
      updateShippingText(shippingSpendTextElement, backShippingTextInt);
      $('.product__accordion').each(function() {
        const summaryElement = $(this).find('summary');
        if (summaryElement.length && summaryElement.text().trim() === "Find In Store") {
          $(this).hide();
        }
      });
    }
  }, "jsonp");
}

changeToDatePicker = () => {
  $('#birthdayInput').prop('type', 'date');
  $('#birthdayInput').off('click touchstart', changeToDatePicker);
}

// Event listener to change input type back to text if value is empty
changeToText = () => {
  var $input = $('#birthdayInput');
  if (!$input.val()) {
    $input.prop('type', 'text');
    $input.on('click touchstart', changeToDatePicker);
  }
}

datePickerListener = () => {
  $('#birthdayInput').on('click touchstart', changeToDatePicker);
  $('#birthdayInput').on('blur', changeToText);
}

clickFaqButton = (button, linkLabel) => {
  $('.text-button').removeClass('faq-active');
  $(button).addClass('faq-active');
  
  $('.is-selected').removeClass('is-selected');
  $(button).parent().addClass('is-selected');

  var targetId = '#' + linkLabel.replace(/[,&\s-]+/g, "_");

  var $targetElement = $(targetId);
  var offset = $targetElement.offset().top;

  var additionalOffset = -303; 
  offset += additionalOffset;

  $('html, body').animate({
    scrollTop: offset
  }, 500);
}

updateFaqID = () => {
  if ($('.collapsible-content').length > 0) {
    $('.collapsible-content').each(function() {
      var currentId = $(this).attr('id');
      var newId = currentId.replace(/[,&\s-]+/g, "_");
      $(this).attr('id', newId);
    });
  }
}

initflickityCarouselPage = () =>{
  var timesRun = 0;
  var timer = setInterval(function() {
      if ($('.jsccarouselpage .shg-row').length > 0) {
        $('.jsccarouselpage .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 2000,
          wrapAround: true,
          groupCells: false
        });
        clearInterval(timer);
        $('.jsccarouselpage .shg-row').flickity('destroy');
        $('.jsccarouselpage .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 2000,
          wrapAround: true,
          groupCells: false
        });
      }

      timesRun += 1;
      if(timesRun === 100){
          clearInterval(timer);
      }

    }, 1);
}

initflickityCarouselstorePageonclick = () =>{
  $(".jsc-accordion-stores .shogun-accordion-heading").click(function(){
    var timesRun = 0;
    var timer = setInterval(function() {
      $('.jsc-stores-carousel .shg-row').flickity();
      $('.jsc-stores-carousel .shg-row').flickity('destroy');
      var screenWidth = $(window).width();
      if (screenWidth <= 767) {
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
        $('.jsc-stores-carousel .shg-row').flickity('destroy');
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
      } else {
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
        $('.jsc-stores-carousel .shg-row').flickity('destroy');
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
      }

      $('.jsc-stores-carousel .flickity-page-dots').each(function() {
        var dotsize = $(this).find('.flickity-page-dot').length;
        var dotwidth = 100/dotsize;
        $(this).find('.flickity-page-dot').css("width", dotwidth + "%");
      });

      timesRun += 1;
      if(timesRun === 1){
          clearInterval(timer);
      }

    }, 1500);
  });
}

initFaqSlider = () => {
  if ($('.jsc-carousel').length > 0) {
    var flkty = new Flickity( '.jsc-carousel' , {
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      groupCells: false,
      wrapAround: false,
      draggable: true,
      prevNextButtons: false,
      autoPlay: false,
    });
  }
}

initComplementary = () => {
  var timer = setInterval(function() {
    if($(".flickity-complementary .product-card").length > 0){
      $('.flickity-complementary').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: false,
        draggable: true,
        autoPlay: 2000,
        prevNextButtons: false
      });
      clearInterval(timer);
    }
  }, 100);
}

initCartDrawerYMLSlider = () => {
  const intervalId = setInterval(() => {
    if ($('.cart-drawer--recommendations--products').length > 0) {
      var flkty = new Flickity('.jsc-yml-carousel', {
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        autoPlay: false,
        adaptiveHeight: false,
        groupCells: true,
      });

      clearInterval(intervalId);
    }
  }, 100);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
}

destroyFAQSlider = () =>{
    $('.jsc-carousel').flickity();
    $('.jsc-carousel').flickity('destroy');
}

destroyCarouselstore = () =>{
  $('.jsc-stores-carousel .shg-row').flickity();
  $('.jsc-stores-carousel .shg-row').flickity('destroy');
  var screenWidth = $(window).width();
  if (screenWidth <= 767) {
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
    $('.jsc-stores-carousel .shg-row').flickity('destroy');
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
  } else {
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
    $('.jsc-stores-carousel .shg-row').flickity('destroy');
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
  }
  $('.jsc-stores-carousel .flickity-page-dots').each(function() {
    var dotsize = $(this).find('.flickity-page-dot').length;
    var dotwidth = 100/dotsize;
    $(this).find('.flickity-page-dot').css("width", dotwidth + "%");
  });
}

destroyYMLSlider = () =>{
  $('.jsc-yml-carousel').flickity();
  $('.jsc-yml-carousel').flickity('destroy');
}

var prevWidth = window.innerWidth;
$( window ).resize(function() {
  var width = window.innerWidth;
  if (width !== prevWidth) {
  destroyFAQSlider();
  initFaqSlider();
  destroyYMLSlider();
  initCartDrawerYMLSlider();
  destroyFeaturedCollectionSlider();
  initFeaturedCollectionSlider();
  destroyCarouselstore();
}
});

editAddressForm = (evt) => {
  var addressID = $(evt).attr('data-address-id');
  console.log("addressID", addressID);

  var matchingElement = $('#EditAddress_' + addressID + '.jsc-edit-address-form');
  var addressRow = $('.jsc-address-view[data-address-id="' + addressID + '"]');

  if (matchingElement.attr('open')) {
    matchingElement.removeAttr('open');
    matchingElement.hide();
    addressRow.show();
  } else {
    $('.jsc-edit-address-form[open]').removeAttr('open').hide();
    $('.jsc-address-view').show();

    // Open the clicked form
    matchingElement.attr('open', '');
    matchingElement.show();
    addressRow.hide();
  }
}
addAddressForm = (evt) => {

  if ($('.jsc-add-address-form').attr('open')) {
    $('.jsc-add-address-form').removeAttr('open');
    $('.jsc-add-address-form').hide();
    $('.jsc-add-new-address-button').show();
  } else {
    $('.jsc-add-address-form').attr('open', '');
    $('.jsc-add-address-form').show();
    $('.jsc-add-new-address-button').hide();
  }
}

toggleDropDownIcon = (select) => {
  var isFirstClick = true;
  var parentElement = $(select).parent();
  var selectArrow = parentElement.find('.select-arrow');
  selectArrow.data('rotation', 0);

  $(select).on('click blur', function(event) {
      if (event.type === 'click') {
          if (isFirstClick) {
              selectArrow.css('transform', 'translateY(-50%) rotate(-180deg)');
              isFirstClick = false;
          } else {
              var currentRotation = selectArrow.data('rotation') || 0;
              var newRotation = currentRotation == 0 ? -180 : 0;
              selectArrow.css('transform', 'translateY(-50%) rotate(' + newRotation + 'deg)');
              selectArrow.data('rotation', newRotation);
          }
      } else if (event.type === 'blur') {
          selectArrow.css('transform', 'translateY(-50%) rotate(0deg)');
          selectArrow.data('rotation', 0);
      }
  });
}

applyToSelectInput = () => {
  $('.jsc-select_input').each(function() {
    toggleDropDownIcon(this);
  });
}

//set User birthday
setCustomerbirthday = (element) =>{
  var $targetElement = $(element);
  var $ancestor = $targetElement.closest('.shopify-section');
  var selectedSectionID = $ancestor.attr('id').replace('shopify-section-','').replace(' ','');
  var selectedSectionIDpath = "?sections=" + $ancestor.attr('id').replace('shopify-section-','').replace(' ','');

  var $return = {};
  $return['mail'] = $('#email-address').val();

  var cusDay = parseInt($('#birthday_date_day').val());
  var cusMonth = parseInt($('#birthday_date_month').val());
  var cusYear = parseInt($('#birthday_date_year').val());

  var $fulldate =   refulldate = cusDay + '/' + cusMonth  + '/' + cusYear ; 

  if ((!isNaN(cusDay) && cusDay != "") && (!isNaN(cusMonth) && cusMonth != "") && (!isNaN(cusYear) && cusYear != "")) {

    console.log(cusDay,cusMonth,cusYear);
    $return['day'] = cusDay;
    $return['month'] = cusMonth;
    $return['year'] = cusYear;

    console.log($return,$fulldate);

    var settings = {
        "url": "https://webhooks.mechanic.dev/4b0b90b9-24a8-4386-a72b-bbb2565916ac",
        "method": "POST",
        "headers": {
            "Content-Type": "application/json"
        },
        "data" : JSON.stringify($return)
    };
    $.ajax(settings).done(function(r){
        console.log('success webhook');
        var retryCount = 0;
        var maxRetries = 20;

        fetchAndUpdateContent = () => {
          fetch(window.location.pathname + selectedSectionIDpath)
          .then(res => res.json())
          .then((restext) => {
            // Extract new content from fetched data
            var newContent = restext[selectedSectionID];
            var $tempElement = $('<div>').html(newContent);
            var content = $tempElement.find('.jsc_info_account_title.jsc-main-account-info').text();
            
            if (content.trim() !== "") {
            clearInterval(intervalID); 
            $ancestor.children().remove();
            $ancestor.html(newContent);
            } else if (retryCount >= maxRetries) {
            clearInterval(intervalID); 
            location.reload();
            }
          })
          .catch((error) => {
            console.error('Error fetching content:', error);
            retryCount++;
          });
  
          retryCount++;
        };
      var intervalID = setInterval(fetchAndUpdateContent, 500);
    }).fail(function(response) {
      console.log("error");
      console.log(response);
      // Happens when something goes wrong
    });
  }else{
    
    $('.birthday_input_error').show();
    setTimeout(function(){
      $('.birthday_input_error').hide();
    }, 2000);
  }
}

//set User name
setCustomerName = () =>{
  var $return = {};
  $return['mail'] = $('#email-address').val();
  $return['firstName'] = $('#userFirstName').val();
  $return['lastName'] = $('#userLastName').val();

  console.log($return);

  if (($return['mail'] != "") && ($return['firstName'] != "") && ($return['lastName'] != "")) {

    var settings = {
        "url": "https://webhooks.mechanic.dev/0299e9fc-0500-45c4-b57a-69fd9d3cbd06",
        "method": "POST",
        "headers": {
            "Content-Type": "application/json"
        },
        "data" : JSON.stringify($return)
    };
    $.ajax(settings).done(function(r){
        console.log('success webhook');
        setTimeout(function(){
          location.reload();
        }, 2000);
    }).fail(function(response) {
        console.log("error");
        console.log(response);
        // Happens when something goes wrong
    });
  }else{
    $('.name_input_error').show();
    setTimeout(function(){
      $('.name_input_error').hide();
    }, 2000);
  }
}

showEditNameForm = () => {
  $('.jsc-account-details-data').hide();
  $('.jsc-edit-name-button').hide();
  $('#jsc-edit-name-form').show();
}

cancelNameForm = () => {
  $('.jsc-account-details-data').show();
  $('.jsc-edit-name-button').show();
  $('#jsc-edit-name-form').hide();
}
updateGridHeightblog = () => {
  var $maxHeight = 0;
  $('.blog-post-list').each(function(){
    var $ConTentHeight = $(this).outerHeight();
    if ($maxHeight < $ConTentHeight) {
      $maxHeight = $ConTentHeight;
    }

  });
  $('.blog-post-list').css("height", $maxHeight + "px");

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.blog-post-list').removeAttr("style");

    setTimeout(function(){
      var $maxHeight = 0;
      $('.blog-post-list').each(function(){
        var $ConTentHeight = $(this).outerHeight();
        if ($maxHeight < $ConTentHeight) {
          $maxHeight = $ConTentHeight;
        }

      });
      $('.blog-post-list').css("height", $maxHeight + "px");
    },1000);
  }

  });
}

checkScreenSizeForOrderPagination = () => {
  var screenWidth = $(window).width();
  if (screenWidth <= 480) {
      $('.jsc-order-desktop-view').hide();
      $('.jsc-order-mobile-view').show();
  } else {
      $('.jsc-order-desktop-view').show();
      $('.jsc-order-mobile-view').hide();
  }
}

var interReturnGoButton;
returnPortalAdjustMargin = () => {
  var totalElements = $('.ReturnGO_UploadImages-module_uploadedImageWrapper').length;
  var screenWidth = $(window).width();
  console.log("totalElements", totalElements);
  if ((totalElements == 0)  && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if ((totalElements == 0)  && screenWidth <= 390) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if ((totalElements == 1 || totalElements == 2) && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-50px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '50px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if (totalElements == 3 && screenWidth > 390 && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '140px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-270px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '7px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-150px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }
  else if (totalElements == 3 && screenWidth <= 390) {
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '140px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-230px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '7px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-150px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');

  }else if (totalElements == 4 && screenWidth > 390 && screenWidth <= 480){
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '100px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '90px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }else if (totalElements == 4 && screenWidth <= 390){
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '100px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '50px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }else if (screenWidth > 480){
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    if(totalElements <= 3){
      $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
      $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    }else{
      $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-120px');
      $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    }

  }
}

handleUploadButtonClick = () => {
  console.log("Next button clicked!");
  var selectedElements = $('.ReturnGO_UploadImages-module_uploadImages').length;
  if (selectedElements == 1){
    var intervalId = setInterval(returnPortalAdjustMargin, 1000); // Adjust the interval time as needed
  }
  interReturnGoButton = setInterval(checkAndUpdateReturnGoButtonText, 1000); // Adjust the interval time as needed
}

// preventSearchBarToScroll = () => {
//   $('.search-field').on('keypress', function(event) {
//       event.preventDefault();

//       $(this).val($(this).val() + event.key);
//       console.log("Log", event.key);
//   });
// }

preventSearchBarToScroll = () => {
  var allowedCharacters = /^[a-zA-Z0-9\s\.\,\!\@\#\$\%\^\&\*\(\)\-\_\=\+\[\]\{\}\\\|\;\'\:\"\,\.\/\<\>\?`~]*$/;
  var keysToBlock = ['Tab','F1','F2','F3','F4','F5','F6','F7','F8','F9','F10','F11','F12','Escape','ScrollLock',
                    'Insert','Pause','Home','PageUp','Delete','End','PageDown','NumLock','ContextMenu','CapsLock'];

  $('.search-field').on('keydown', function(event) {
    var oldScroll = $(window).scrollTop();

    $( window ).one('scroll', function() {
        $(window).scrollTop( oldScroll ); //disable scroll just once
    });
  });
}


//Start - Marquee function
newBlogMarquee = () =>{
  var promoNum = parseInt($('#scroll_textblog').length);
  if (promoNum >= 1) {
    // $('#scroll_textblog').addClass('p-b-23');
    $('#scroll_textblog').marquee({

    //If you wish to always animate using jQuery
    allowCss3Support: true,

    //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
    css3easing: 'linear',

    //requires jQuery easing plugin. Default is 'linear'
    easing: 'linear',

    //pause time before the next animation turn in milliseconds
    delayBeforeStart: 1000,
    //'left', 'right', 'up' or 'down'
    direction: 'left',

    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,

    //speed in milliseconds of the marquee in milliseconds
    duration: 45000,

    //gap in pixels between the tickers
    gap: 20,

    //on cycle pause the marquee
    pauseOnCycle: false,

    //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
    pauseOnHover: false,

    //the marquee is visible initially positioned next to the border towards it will be moving
    startVisible: false

    });
  }

}

newMarquee = () =>{
  var promoNum = parseInt($('#numOfPromo').val());
  if (promoNum > 1) {
    // $('#scroll_text').addClass('p-b-23');
    $('#scroll_text, #scroll_text_desktop').marquee({

    //If you wish to always animate using jQuery
    allowCss3Support: true,

    //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
    css3easing: 'linear',

    //requires jQuery easing plugin. Default is 'linear'
    easing: 'linear',

    //pause time before the next animation turn in milliseconds
    delayBeforeStart: 1000,
    //'left', 'right', 'up' or 'down'
    direction: 'left',

    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,

    //speed in milliseconds of the marquee in milliseconds
    duration: 21000,

    //gap in pixels between the tickers
    gap: 20,

    //on cycle pause the marquee
    pauseOnCycle: false,

    //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
    pauseOnHover: false,

    //the marquee is visible initially positioned next to the border towards it will be moving
    startVisible: false

    });
  }

}
//End - Marquee function
//Start - Toggle Size
togglesizenew = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  if (ischecked == true) {
    $(evt).parents('.prod-measurement-accordion').find(".cmdescription").each(function () {
      $(this).removeClass("activetogglesize");
    });
    $(evt).parents('.prod-measurement-accordion').find(".inchdescription").each(function () {
      $(this).addClass("activetogglesize");
    });
  }else{
    $(evt).parents('.prod-measurement-accordion').find(".cmdescription").each(function () {
      $(this).addClass("activetogglesize");
    });
    $(evt).parents('.prod-measurement-accordion').find(".inchdescription").each(function () {
      $(this).removeClass("activetogglesize");
    });
  }
}
togglesize = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  var iscmadded= $(evt).attr("data-cm-added");
  if (!iscmadded) {
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacm = $(this).text();
      $(this).attr("data-cm",datacm);
    });
  }
  $(evt).attr("data-cm-added", 'true');
  if (ischecked == true) {
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      if ($(this).attr("data-cm").includes('-')) {
        var cmarray = $(this).attr("data-cm").split("-");
        var datacmconvert1 = parseInt(cmarray[0]);
        var datainconvert1 = datacmconvert1/2.54;
        datainconvert1 = parseFloat(datainconvert1.toFixed(2));
        var datacmconvert2 = parseInt(cmarray[1]);
        var datainconvert2 = datacmconvert2/2.54;
        datainconvert2 = parseFloat(datainconvert2.toFixed(2));
        $(this).text(datainconvert1 + '-' + datainconvert2)
      }else{
      var datacmconvert = parseInt($(this).attr("data-cm"));
      var datainconvert = datacmconvert/2.54;
      datainconvert = parseFloat(datainconvert.toFixed(2));
      $(this).text(datainconvert)
      }
    });
  }else{
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacmconvert = $(this).attr("data-cm");
      $(this).text(datacmconvert)
    });
  }
}
togglesizepopupnew = (evt) => {
  var ischecked = $(evt).find('input').is(':checked');
  if (ischecked == true) {
    $(evt).parents('.sizepopup').find(".switch input").prop('checked',true);
    var selectedtab = $(evt).parents('.sizepopup').find(".sizepopupcm").find(".js-active").attr("href");
    $(evt).parents('.sizepopup').find(".sizepopupinch").find(".tabs a").each(function () {
      if ($(this).attr("href") == selectedtab) {
        $(this).click();
      }
    });
    $(evt).parents('.sizepopup').find(".sizepopupcm").each(function () {
      $(this).removeClass("activesizepopupcont");
    });
    $(evt).parents('.sizepopup').find(".sizepopupinch").each(function () {
      $(this).addClass("activesizepopupcont");
    });
  }else{
    $(evt).parents('.sizepopup').find(".switch input").prop('checked',false);
    var selectedtab = $(evt).parents('.sizepopup').find(".sizepopupinch").find(".js-active").attr("href");
    $(evt).parents('.sizepopup').find(".sizepopupcm").find(".tabs a").each(function () {
      if ($(this).attr("href") == selectedtab) {
        $(this).click();
      }
    });
    $(evt).parents('.sizepopup').find(".sizepopupcm").each(function () {
      $(this).addClass("activesizepopupcont");
    });
    $(evt).parents('.sizepopup').find(".sizepopupinch").each(function () {
      $(this).removeClass("activesizepopupcont");
    });
  }
}
togglesizepopup = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  var iscmadded= $(evt).attr("data-cm-added");
  if (!iscmadded) {
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacm = $(this).text();
      $(this).attr("data-cm",datacm);
    });
  }
  $(evt).attr("data-cm-added", 'true');
  if (ischecked == true) {
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      if ($(this).attr("data-cm").includes('-')) {
        var cmarray = $(this).attr("data-cm").split("-");
        var datacmconvert1 = parseInt(cmarray[0]);
        var datainconvert1 = datacmconvert1/2.54;
        datainconvert1 = parseFloat(datainconvert1.toFixed(2));
        var datacmconvert2 = parseInt(cmarray[1]);
        var datainconvert2 = datacmconvert2/2.54;
        datainconvert2 = parseFloat(datainconvert2.toFixed(2));
        $(this).text(datainconvert1 + '-' + datainconvert2)
      }else{
      var datacmconvert = parseInt($(this).attr("data-cm"));
      var datainconvert = datacmconvert/2.54;
      datainconvert = parseFloat(datainconvert.toFixed(2));
      $(this).text(datainconvert)
      }
    });
  }else{
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacmconvert = $(this).attr("data-cm");
      $(this).text(datacmconvert)
    });
  }
}
appendtogglesize = () => {
  $(".sizepopup .tabs-content li table:first-child tr:not(.size_table_color) th").each(function () {
    $(this).append('<div class="togglesize"><span>CM</span><label onclick="togglesizepopupnew(this);" class="switch"><input type="checkbox"><span class="slider round"></span></label><span>IN</span></div>');
  });
  if ($(".sizepopup .tabs-content li table:first-child tr:not(.size_table_color) th").length <= 0) {
    $(".sizepopup .tabs-content").each(function () {
      $('<div class="togglesize"><span>CM</span><label onclick="togglesizepopupnew(this);" class="switch"><input type="checkbox"><span class="slider round"></span></label><span>IN</span></div>').insertBefore(this);
    });
  }
}
closesizepopup = () =>{
  $('.sizepopupoverlay').hide();
  $('.sizepopup').hide();
  $("body").css('overflow', 'auto');
}
//End - Toggle Size

// start: update quick view overlay
updateOverlay = () => {
  $('#wrapper .click-capture').css('z-index', '52');
}
// end: update quick view overlay

checkAndUpdateReturnGoButtonText = () => {
  var backButton = $(".ReturnGO_Button-module_secondary");
  var backButtonSpan = backButton.find("span");
  if (backButtonSpan.text().trim() === "Go Back") {
    backButtonSpan.text("Back");
  }
}

shopLookHover = () => {

  $('.shop-the-look').each(function() {
    $(this).on('mouseenter', function(event) {
      $(this).find('.thb-hotspot-content').addClass('ishover');
    });

    $(this).on('mouseleave', function(event) {
      $('.thb-hotspot-content').removeClass('ishover');
    });
    // For mobile & ipad device (if needed)
    // $(this).on('touchstart click', function(event) {
    //   event.stopPropagation();
    //   $('.thb-hotspot-content').removeClass('ishover');
    //   $(this).find('.thb-hotspot-content').addClass('ishover');
    // });

    // $(document).on('touchstart click', function() {
    //   $('.thb-hotspot-content').removeClass('ishover');
    //   console.log($(document));
    // });
  });
}

featureCollectionAutoTitleSwitcher = () => {
  if ($('.jsc-fc-slider-carousel').length == 0) {
    var $fcTitle = $('.featured-collection-list--inner--content .featured-collection-list--button');
    var $fcImage = $('.featured-collection-list--bg .jsc-feat-coll-image');
    var setIntervalTime = parseInt($('#setTitleSwithcherIntervalTime').val());
    var totalNumberFCTitle = $fcTitle.length;

    var currentIndex = 0;
    var switchInterval;

    switchToNextButton = () => {
      $fcTitle.removeClass('active');
      $fcImage.find('.featured-collection-list--img').removeClass('active');

      currentIndex = (currentIndex + 1) % totalNumberFCTitle;
      $fcTitle.eq(currentIndex).addClass('active');
      $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
    }

    startSwitching = () => {
      switchInterval = setInterval(switchToNextButton, setIntervalTime);
    }

    stopSwitching = () => {
      clearInterval(switchInterval);
    }

    $fcTitle.eq(currentIndex).addClass('active');
    $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');

    startSwitching();

    $fcTitle.hover(
      function() {
        // When hover starts, stop the auto switch
        stopSwitching();
        // Update the currentIndex to the hovered button index
        currentIndex = $fcTitle.index(this);
      },
      function() {
        // When hover ends, resume the auto switch
        startSwitching();
      }
    );
  }
}

updateProductAddToCartSticky = () => {
  var contentElement = $(".product-add-to-cart-sticky--content");
  var plusElement = $(".product-add-to-cart-sticky--inner .plus");
  var minusElement = $(".product-add-to-cart-sticky--inner .minus");
  var back_to_top = $(".back-to-top");

  if (contentElement.hasClass("active")) {
    plusElement.hide();
    minusElement.show();
    back_to_top.css("z-index", 1);
  } else {
    plusElement.show();
    minusElement.hide();
    back_to_top.css("z-index", 30);
  }
}

removeQuantitySelectorOverlay = () => {
  $('.minus').removeAttr('disabled');
  $('.minus.jsc-quantity-selector-overlay').removeClass('jsc-quantity-selector-overlay');
  $('.plus').removeAttr('disabled');
  $('.plus.jsc-quantity-selector-overlay').removeClass('jsc-quantity-selector-overlay');
}

headerbgchange = () => {
  setTimeout(function() {
    $('#header').css("background","var(--hamburger-active-color)");
    $('#mobile-menu').css("background","var(--hamburger-active-color)");
    $('.jsc-account-menu').css("background","var(--hamburger-active-color)");
    $('#header').addClass('jsc-second-level-active');
    var isLoggedIn = $('.jsc-second-level-logged-in-icon').attr('data-logged-in');
    if(isLoggedIn){
      $('.jsc-second-level-logged-in-icon').hide();
      $('.jsc-logged-in-icon').show();
    }
  }, 280);
}

headerbgclose = () => {
  setTimeout(function() {
    $('#header').removeAttr("style");
    $('#mobile-menu').removeAttr("style");
    $('.jsc-account-menu').removeAttr("style");
    $('#header').css("background","#ffffff");
    $('#mobile-menu').css("background","#ffffff");
    $('.jsc-account-menu').css("background", "#ffffff");
    $('#header').removeClass('jsc-second-level-active');
    var isLoggedIn = $('.jsc-second-level-logged-in-icon').attr('data-logged-in');
    if(isLoggedIn){
      $('.jsc-second-level-logged-in-icon').hide();
      $('.jsc-logged-in-icon').show();
    }
  }, 300);
}

let isToggled = false;

cartNotesToggle = () => {
  $(".cart-notes-title").click(function(event) {
    event.preventDefault();

    if (isToggled) {
      $("#CartSpecialInstructions").css({'min-height': '', 'max-height': ''});
      $(this).find(".cart-notes-collapse-plus-icon").show();
      $(this).find(".cart-notes-collapse-minus-icon").hide();
    } else {
      $("#CartSpecialInstructions").css({'min-height': '100px', 'max-height': 'unset'});
      $(this).find(".cart-notes-collapse-plus-icon").hide();
      $(this).find(".cart-notes-collapse-minus-icon").show();

    }
    isToggled = !isToggled;
  });

  $('#CartSpecialInstructions').on('keydown', function(event) {
    if (!isToggled) {
      $(this).css({'min-height': '100px', 'max-height': 'unset'});
      $(".cart-notes-title").find(".cart-notes-collapse-plus-icon").hide();
      $(".cart-notes-title").find(".cart-notes-collapse-minus-icon").show();
      isToggled = true;
    }
  });
}

initWrapperCloseButton = () => {
  var initialBackgroundColor = $('#header').css('background-color');
  var initialHexColor = rgbaToHex(initialBackgroundColor);
  var wrapperOpen = false;
  var $headerSearchWrap = $('.header-search-wrap.header-search-mob-icon');
  var $searchInnerIcon = $('.search-icon .cls-1.jsc-colour-page');
  var $searchIconColor = $('.header-search-wrap.header-search-mobile .search-icon .jsc-colour-page');
  var $headerSearchMobile = $('.header-search-mobile');
  var $whiteIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-white');
  var $greenIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-green');
  var $greenIconpath = $('.header-search-wrap.header-search-mob-icon .jsc-close-green path');

  $(document).on('click', '.mobile-toggle-wrapper summary.mobile-toggle', function() {
    setTimeout(function(){
    $('#header').removeAttr("style");
    $('#mobile-menu').removeAttr("style");
    $('.jsc-account-menu').removeAttr("style");
    if(wrapperOpen){//close
      $('#header').css("background", initialHexColor);
      $('#mobile-menu').css("background", "#ffffff");
      $('.jsc-account-menu').css("background", "#ffffff");
      $('#header').removeClass('jsc-second-level-active');
      $('.jsc-second-level-logged-in-icon').hide();
      $('.jsc-logged-in-icon').show();
      if ($headerSearchWrap.attr('color-page-active') == 'true') {
        console.log("Wrapper close -1");
        $searchIconColor.css("fill", "#ffffff");
        $searchInnerIcon.css('fill', '#ffffff');
        $greenIconpath.css('stroke', '#ffffff');
        $('.header-search-wrap .searchform.text-white-color fieldset input').css({"border-color": "#ffffff","color": "#ffffff"});
        $('.header-search-wrap .searchform.text-white-color fieldset input').removeClass('jsc-alternate-placeholder-color');
        $('.header-search-wrap .searchform.text-white-color fieldset input::placeholder').css({"color": "#ffffff"});
      }
      wrapperOpen = false;
    }else{//open
      $('#header').css("background", "#ffffff");
      $('#mobile-menu').css("background", "#ffffff");
      $('.jsc-account-menu').css("background", "#ffffff");
      if ($headerSearchWrap.attr('color-page-active') == 'true') {
        console.log("Wrapper open -2");
        $searchIconColor.css({"fill": "var(--search-color)"});
        $searchInnerIcon.css({"fill": "var(--search-color)"});
        $greenIconpath.css('stroke', 'var(--search-color)');
        $('.header-search-wrap .searchform.text-white-color fieldset input').css({"border-color": "var(--search-color)","color": "var(--search-color)"});
        $('.header-search-wrap .searchform.text-white-color fieldset input').addClass('jsc-alternate-placeholder-color');
        $('.header-search-wrap .searchform.text-white-color fieldset input::placeholder').css({"color": "var(--search-color)"});
      }
      wrapperOpen = true;
    }
    }, 250);
  });
}

rgbaToHex = (rgba) => {
  var result = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.?\d*))?\)$/.exec(rgba);
  return result ? "#" +
    ("0" + parseInt(result[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(result[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(result[3], 10).toString(16)).slice(-2) +
    (result[4] ? (parseFloat(result[4]) * 255).toString(16).slice(0, 2) : '') : rgba;
}

updateNote = () => {
  var $noteElement = $('#CartSpecialInstructions');
  console.log("Note value:", $noteElement.val());
  CartJS.setNote($noteElement.val());
}

bannerLinkInit = (event, bannerLink) => {
  console.log("init banner link");
  var $clickedElement = $(event.target);

  if (!$clickedElement.is('span.h1-large')) {
    window.location.href = bannerLink;
  }
}

initFeaturedCollectionSlider = () => {
  const intervalId = setInterval(() => {
    if ($('.jsc-fc-slider-carousel').length > 0) {
      var flkty = new Flickity('.jsc-fc-slider-carousel', {
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        autoPlay: false,
        adaptiveHeight: false,
        groupCells: true,
      });
      var currentHeight = $('.featured-collection-list--bg.jsc-fc-slider-carousel .flickity-viewport').height();
      // console.log("currentHeight", currentHeight);
      $('.featured-collection-list').css('height', currentHeight + 'px');
      // $('.jsc-fc-slider-carousel .flickity-viewport').css('max-height', currentHeight + 'px');
      // $('.jsc-fc-slider-carousel .flickity-viewport').css('height', currentHeight + 'px');
      // $('.jsc-fc-collection-list-slider .featured-collection-list--bg img').css('height', currentHeight + 'px');

      clearInterval(intervalId);
    }
  }, 100);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
}

destroyFeaturedCollectionSlider = () =>{
  $('.jsc-fc-slider-carousel').flickity();
  $('.jsc-fc-slider-carousel').flickity('destroy');
}

featureCollectionAutoTitleSwitcherSlider = () => {
  if ($('.jsc-fc-slider-carousel').length > 0) {
    var $enableTitleSwitcher = $('.jsc-fc-slider-carousel').attr('data-title-switcher');
    var $fcTitle = $('.jsc-fc-collection-list-slider .featured-collection-list--inner--content .featured-collection-list--button');
    var $fcImage = $('.jsc-fc-collection-list-slider .featured-collection-list--bg .jsc-feat-coll-image');
    
    if ($enableTitleSwitcher == "true"){
      var setIntervalTime = parseInt($('#setTitleSwithcherIntervalTime').val());
      var totalNumberFCTitle = $fcTitle.length;
  
      var currentIndex = 0;
      var switchInterval = null;
  
      switchToNextButton = () => {
        $fcTitle.removeClass('active');
        $fcImage.find('.featured-collection-list--img').removeClass('active');
        $fcImage.removeClass('is-selected');
        
        currentIndex = (currentIndex + 1) % totalNumberFCTitle;
  
        $fcTitle.eq(currentIndex).addClass('active');
        $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
        $fcImage.eq(currentIndex).addClass('is-selected');
  
        renderFeatCollTextColor();
        
        $('.flickity-page-dot').eq(currentIndex).click();
      }
  
      startSwitching = () => {
        renderFeatCollTextColor();
        if (switchInterval !== null) {
          clearInterval(switchInterval);
        }
        switchInterval = setInterval(switchToNextButton, setIntervalTime);
      }
  
      stopSwitching = () => {
        renderFeatCollTextColor();
        if (switchInterval !== null) {
          clearInterval(switchInterval);
          switchInterval = null;
        }
      }

      var attemptCount = 0;
      var maxAttempts = 30;
      
      checkAndAttachEvent = () => {
        var $elements = $('.buckscc-select-styled');
        if ($elements.length > 0) { 
          $elements.each(function() {
              var $this = $(this);
              if (!$this.data('hasClickListener')) {
                $this.on('click', function() {
                  checkCurrencyVisible($this);
                }).data('hasClickListener', true);
              }
            });
            clearInterval(checkInterval);
        } else if (++attemptCount >= maxAttempts) {
          clearInterval(checkInterval);
        }
      }
      var checkInterval = setInterval(checkAndAttachEvent, 1000);

      $fcTitle.eq(currentIndex).addClass('active');
      $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
      $fcImage.eq(currentIndex).addClass('is-selected');

      let isHovered = false;
  
      startSwitching();
      if (window.innerWidth > 1024) {
        $fcTitle.hover(
          function() {
            isHovered = true;
            stopSwitching();
            currentIndex = $fcTitle.index(this);
          },
          function() {
            isHovered = false;
            startSwitching();
          }
        );
      }
  
    $('.jsc-fc-slider-carousel .flickity-page-dots .flickity-page-dot').on('click', function() {

      if (!isHovered) {
        stopSwitching();

        $fcTitle.removeClass('active');
        $fcImage.find('.featured-collection-list--img').removeClass('active');
        $fcImage.removeClass('is-selected');
        
        currentIndex = $('.jsc-fc-slider-carousel .flickity-page-dot').index(this);
        
        $fcTitle.eq(currentIndex).addClass('active');
        $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
        $fcImage.eq(currentIndex).addClass('is-selected');
        startSwitching();
      } else {
        stopSwitching();
      }
    });

    $('.jsc-fc-slider-carousel').on('select.flickity', function(event, index) {
      currentIndex = index;
      if (!isHovered) {
        stopSwitching();
        $fcTitle.removeClass('active');
        $fcTitle.eq(index).addClass('active');
        startSwitching();
      } else {
        stopSwitching();
      }
    });
    }else{
      $('.jsc-fc-slider-carousel').on('select.flickity', function(event, index) {
        currentIndex = index;
        $fcTitle.removeClass('active');
        $fcTitle.eq(index).addClass('active');
        renderFeatCollTextColor();
      });
    }

    $(document).on('click', function(event) {
      var $target = $(event.target);
      if ($target.closest('.buckscc-select-styled').length > 0) {
      } else {
        if ($('.buckscc-select-styled').hasClass('active') && $('.buckscc-select-styled').hasClass('deactive')) {
          startSwitching();
        }
      }
    });

    checkCurrencyVisible = (element) => {
      if ($(element).hasClass('active') && $(element).hasClass('deactive')) {
        startSwitching();
      } else if ($(element).hasClass('active')) {
        stopSwitching();
      }
    }
  }
}
renderFeatCollTextColor = () => {
  if($('.jsc-fc-collection-list-slider .featured-collection-list--button').length > 0){
    $('.featured-collection-list--button').each(function() {
      if ($(this).hasClass('active')) {
        var inactiveTextColor = $(this).data('inactive-text');
        $('.featured-collection-list--button').not('.active').css('--color-inactive-text', inactiveTextColor);
        $('.featured-collection-list--button').not('.active').find('span').css('--color-inactive-text', inactiveTextColor);
      }
    });
  }
}
blockBannerLinkInit = (event) => {
  var activeButton = $('.featured-collection-list--button.active');
  if (activeButton.length) {
    activeButton[0].click();
  }
}

checkShogunPages = () => {
  $('.shogun-root[data-shogun-id="669f0ee5c94cd70edcb1222a"] .shg-box.shg-c.shg-box-linked').each(function() { //change the id by following data-shogun-id, if the data-shogun-id changed
      var $targetElement = $(this);
      var dataHref = $targetElement.data('shg-href');
      
      var $link = $('<a>', {
          href: dataHref,
          class: 'jsc-shogun-cover-link'
      });

      $targetElement.wrap($link);
  });
}
earlyaccesslimit = () =>{ 
  setTimeout(function () {
    $('.product-grid-container .product-information--inner').each(function () {
      var thisprodInfo = $(this);            
      $('.var-limit-list').each(function(){
        var varID = $(this).val();
        if (varID == thisprodInfo.find(".variant-selected-form").val()) {
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
        }
      });
      $('.var-limit-product-list').each(function(){
        var varID = $(this).val();
        if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
        }
      });
    });
  }, 100);
}

removeItemcart = (varid) =>{
  var jsonObj = {};
  jsonObj[varid] = 0;
  CartJS.updateItemQuantitiesById(jsonObj);
}

quickatcgrid = (varid) =>{
  var jsonObj = [];
  var item = {};
  item ["id"] = varid;
  item ["quantity"] = 1;
  item ["properties"] = {};
  jsonObj.push(item);
  cartJSAddSQuery(jsonObj);
}

initswatchflickity = () => {
  var timer = setInterval(function() {
    if(initFlickity){
      if($('.product-card-swatches:not(.flickity-enabled)').length > 0){
        $('.product-card-swatches:not(.flickity-enabled)').flickity({
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          groupCells: false,
          wrapAround: false,
          draggable: true,
          prevNextButtons: false
        });
        clearInterval(timer);
      }
    }
  }, 10);
}

hoveraddclassprodcard = (evt) =>{
  $(evt).addClass('hovergrid');
}
hoverremoveclassprodcard = (evt) =>{
  $(evt).removeClass('hovergrid');
}

handleGiftwrapOptionChange = (element) => {
  console.log("handleGiftwrapOptionChange");
  CartJS.setAttribute(' I would like my gift wrapped.', element.checked ? 'Yes' : 'No');
  updateNote();
}

handleGwpCartDetailsChange = (element) => {
  console.log("handleGwpCartDetailsChange");
  gwpPopupATC(element);
}

intervalshowfestivegif = () =>{
  setTimeout(function(){
    $('.col-gif-festive').show();
    var show = true;
    var timescount = 0;
    var timesRunhide = 0;
    var timesRun = 0;
    var timesRunhidediff = 6;
    if ($(window).width() < 481) {
      timesRunhidediff = 4;
      var timer = setInterval(function() {
        timescount += 1;
        //console.log(timescount);
        timesRunhide += 1;
        timesRun += 1;
        if(timesRunhide === 45 && show){
          //console.log('hide',timesRunhide,timesRun);
          timesRunhide = 0;
          timesRun = 0;
          timescount = 0;
          $('.col-gif-festive').hide();
          show = false;
        }
        if(timesRun === 90 && show == false){
          //console.log('show',timesRunhide,timesRun);
          timesRunhide = 0;
          timesRun = 0;
          timescount = 0;
          $('.col-gif-festive').show();
          show = true;
        }
  
      }, 100);
    }else{
    var timer = setInterval(function() {
      timescount += 1;
      //console.log(timescount);
      timesRunhide += 1;
      timesRun += 1;
      if(timesRunhide === timesRunhidediff && show){
        //console.log('hide',timesRunhide,timesRun);
        timesRunhide = 0;
        timesRun = 0;
        timescount = 0;
        $('.col-gif-festive').hide();
        show = false;
      }
      if(timesRun === 9 && show == false){
        //console.log('show',timesRunhide,timesRun);
        timesRunhide = 0;
        timesRun = 0;
        timescount = 0;
        $('.col-gif-festive').show();
        show = true;
      }

    }, 1000);
    }
  },3000);
}

updateFeatCollContainerHeight = () => {
  var maxWidth = 1024;
  var windowWidth = $(window).width();

  if (windowWidth <= maxWidth) {
    var $featCollImage = $('.jsc-normal-feat-collection .jsc-feat-coll-image.jsc-fix-coll-img');
    if ($featCollImage.length) {
      var $img = $featCollImage.find('img');
      // console.log("img", $img);
      var naturalHeight = $img[0].naturalHeight;
      $('.featured-collection-list.jsc-normal-feat-collection').css('height', naturalHeight + 'px');
      // console.log("Image width set to:", naturalHeight);
    }
  }else{
    $('.featured-collection-list.jsc-normal-feat-collection').css('height', '');
  }
}

changeProductNoteToSentenceCase = () => {
  $('.jsc-product-note').each(function() {
    $(this).text(function(_, text) {
      return text.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, char => char.toUpperCase());
    });
  });
}

handleGiftWrapChange = () => {
  $(document).on('change', '.main-cart-section .jsc-cartitem-giftwrap-checkbox', function() {
    var checkbox = $(this);
    console.log("checkbox", checkbox);
    var productQuantity = parseInt(checkbox.closest('.product-quantity').find('input').first().val());
    var itemId = checkbox.attr('cart-item-id');
    var itemkey = checkbox.attr('cart-item-key');
    var giftWrapItemId = checkbox.attr('gift-wrap-item-id');
    var giftWrapItemTitle = checkbox.attr('gift-wrap-item-title');
    var giftWrapItemCurrentProperties = checkbox.attr('gift-wrap-item-old-current-properties');
    console.log("giftWrapItemCurrentProperties", giftWrapItemCurrentProperties);
    var bindID = itemId + "-" + giftWrapItemId;
    var giftWrapValue = giftWrapItemTitle;

    var $prodObj = {};
    if(giftWrapItemCurrentProperties != "") {
      var pairs = giftWrapItemCurrentProperties.split(', ');

      pairs.forEach(pair => {
        const [key, value] = pair.split(':');
        $prodObj[key.trim()] = value.trim();
      });
    }

    if (checkbox.prop('checked')) {
      console.log("RUN this 1");
      var jsonObj = [];
      var item = {};
      var $obj = {};
      $obj['_giftWrap bindID'] = bindID;
      $obj['_giftWrap Product'] = 'giftWrap';
      $prodObj['Gift wrap'] = giftWrapValue;
      $prodObj['giftWrap bindID'] = bindID;
      item["id"] = giftWrapItemId;
      item["quantity"] = productQuantity;
      item["properties"] = $obj;
      jsonObj.push(item);
      // Add gift wrap item
      CartJS.addItems(jsonObj, {
        "success": function(data, textStatus, jqXHR) {
          console.log('Success in adding items');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occurred while adding items:", errorThrown);
        }
      });

      CartJS.updateItemById(itemId, productQuantity, $prodObj, {
        "success": function(data, textStatus, jqXHR) {
          console.log('Success in updating item properties');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error updating cart item properties:', errorThrown, jqXHR);
        }
      });

    } else {
      console.log("RUN this 2");
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID, productQuantity);
        if (giftWrapBindID == bindID) {
          console.log("RUN this 3");
          var selectedGiftWrapVarID = giftWrapVarID;
          var jsonObj = {};
          jsonObj[selectedGiftWrapVarID] = 0;
          jsonObj[itemkey] = 0;
          if(giftWrapItemCurrentProperties != "") {
            $.each(["Gift wrap", "giftWrap bindID"], function(index, key) {
              delete $prodObj[key];
            });
          }
          CartJS.updateItemQuantitiesById(jsonObj, {
            "success": function(data, textStatus, jqXHR) {
              console.log('Remove item - updateItemQuantitiesById-variant-id', jqXHR);
              CartJS.addItem(itemId, productQuantity, $prodObj, {
                "success": function(data, textStatus, jqXHR) {
                  console.log('Success in adding items');
    
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                  console.log("Error occurred while adding items:", errorThrown);
                }
              });
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log("Error occurred while updating item quantities:", errorThrown);
            }
          });
        }
      });

    }
  });
}

handleGiftWrapChangeCartDrawer = () => {
  $(document).on('change', '.cart-drawer .jsc-cartitem-giftwrap-checkbox', function() {
    var checkbox = $(this);
    var productQuantity = parseInt(checkbox.closest('.product-cart-item-info').find('input').first().val());
    var itemId = checkbox.attr('cart-item-id');
    var itemkey = checkbox.attr('cart-item-key');
    var giftWrapItemId = checkbox.attr('gift-wrap-item-id');
    var giftWrapItemTitle = checkbox.attr('gift-wrap-item-title');
    var giftWrapItemCurrentProperties = checkbox.attr('gift-wrap-item-old-current-properties');
    var bindID = itemId + "-" + giftWrapItemId;
    var giftWrapValue = giftWrapItemTitle;

    var $prodObj = {};
    if(giftWrapItemCurrentProperties != "") {
      var pairs = giftWrapItemCurrentProperties.split(', ');

      pairs.forEach(pair => {
        const [key, value] = pair.split(':');
        $prodObj[key.trim()] = value.trim();
      });
    }

    if (checkbox.prop('checked')) {
      console.log("RUN this 1");
      var jsonObj = [];
      var item = {};
      var $obj = {};
      $obj['_giftWrap bindID'] = bindID;
      $obj['_giftWrap Product'] = 'giftWrap';
      $prodObj['Gift wrap'] = giftWrapValue;
      $prodObj['giftWrap bindID'] = bindID;
      item["id"] = giftWrapItemId;
      item["quantity"] = parseInt(productQuantity);
      item["properties"] = $obj;
      jsonObj.push(item);
      // Add gift wrap item
      CartJS.addItems(jsonObj, {
        "success": function(data, textStatus, jqXHR) {
          console.log('Success in adding items');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occurred while adding items:", errorThrown);
        }
      });

      CartJS.updateItemById(itemId, productQuantity, $prodObj, {
        "success": function(data, textStatus, jqXHR) {
          console.log('Success in updating item properties');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log('Error updating cart item properties:', errorThrown, jqXHR);
        }
      });

    } else {
      console.log("RUN this 2");
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == bindID) {
          console.log("RUN this 3");
          var selectedGiftWrapVarID = giftWrapVarID;
          var jsonObj = {};
          jsonObj[selectedGiftWrapVarID] = 0;
          jsonObj[itemkey] = 0;
          if(giftWrapItemCurrentProperties != "") {
            $.each(["Gift wrap", "giftWrap bindID"], function(index, key) {
              delete $prodObj[key];
            });
          }
          CartJS.updateItemQuantitiesById(jsonObj, {
            "success": function(data, textStatus, jqXHR) {
              console.log('Remove item - updateItemQuantitiesById-variant-id', jqXHR);
              CartJS.addItem(itemId, productQuantity, $prodObj, {
                "success": function(data, textStatus, jqXHR) {
                  console.log('Success in adding items');
    
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                  console.log("Error occurred while adding items:", errorThrown);
                }
              });
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log("Error occurred while updating item quantities:", errorThrown);
            }
          });
        }
      });

    }
  });
}

handleGiftWrapChangeQTYSelector = (currentElement, currentQuantity) => {

  var $currentElement = $(currentElement);
  var $currentCheckBox = $currentElement.closest('.product-quantity').find('.jsc-checkbox-container .jsc-cartitem-giftwrap-checkbox');
  var itemId = $currentCheckBox.attr('cart-item-id');
  var giftWrapItemId = $currentCheckBox.attr('gift-wrap-item-id');
  var bindID = itemId + "-" + giftWrapItemId;
  var totalQuantity = 0;

  console.log("currentCheckBox", $currentCheckBox);
  console.log("currentQuantity", currentQuantity);
  
  if ($currentCheckBox.is(':checked')) {
    if($('.main-cart-section .jsc-cart-item-giftwrap').length > 0 ) {
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        totalQuantity = totalQuantity + parseInt($(this).find('quantity-selector input').val());
      });
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        var giftWrapVariantID = $(this).attr('data-product-variant-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == bindID && ($('.jsc-limit-giftwrap').length <= 0)) {
          var selectedGiftWrapVarID = giftWrapVarID; 

          var jsonObj = {};
          var currentGiftWrapQty = parseInt($(this).find('quantity-selector input').val());
          var maxQtyToBeAdd = 10 - totalQuantity;
          var currentQTYAdded = currentQuantity - currentGiftWrapQty;
          
          if(currentQTYAdded < maxQtyToBeAdd){
            var actualQtyAdded = currentGiftWrapQty + currentQTYAdded;
          }else{
            var actualQtyAdded = currentGiftWrapQty + maxQtyToBeAdd;
          }
          jsonObj[selectedGiftWrapVarID] = actualQtyAdded;

          // CartJS.updateItemById(selectedGiftWrapVarID, 0, {}, {
          //   success: function(data, textStatus, jqXHR) {
          //     console.log('Success in removing gift wrap', data); // Removed undefined variable itemId
          //   },
          //   error: function(jqXHR, textStatus, errorThrown) {
          //     console.error('Error updating cart item properties after removing gift wrap:', errorThrown); // Corrected to errorThrown
          //   }
          // });
          // CartJS.addItem(giftWrapVariantID, currentQuantity, {"_giftWrap bindID": bindID, "_giftWrap Product": "giftWrap"}, {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Remove item - updateItemQuantitiesById-variant-id', jqXHR);
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while updating item quantities:", errorThrown);
          //   }
          // });
          CartJS.updateItemQuantitiesById(jsonObj, {
            "success": function(data, textStatus, jqXHR) {
              console.log('Remove item - updateItemQuantitiesById-key-id', jqXHR);
              // location.reload();
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log("Error occurred while updating item quantities:", errorThrown);
            }
          });

          // CartJS.removeItemById(selectedGiftWrapVarID, {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Remove item - removeItemById - variant-id', jqXHR);
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while updating item quantities:", errorThrown);
          //   }
          // });
        
          // CartJS.addItems([{id: giftWrapVariantID, quantity: currentQuantity, properties: { "_giftWrap bindID": bindID, "_giftWrap Product": "giftWrap"}}], {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Success in adding items');
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while adding items:", errorThrown, jqXHR);
          //   }
          // });
          
        }
      });
    }
  }
}

handleGiftWrapChangeQTYSelectorCartDrawer = (currentElement, currentQuantity) => {

  var $currentElement = $(currentElement);
  var $currentCheckBox = $currentElement.closest('.product-cart-item.jsc-cart-drawer').find('.jsc-checkbox-container .jsc-cartitem-giftwrap-checkbox');;
  var itemId = $currentCheckBox.attr('cart-item-id');
  var giftWrapItemId = $currentCheckBox.attr('gift-wrap-item-id');
  var bindID = itemId + "-" + giftWrapItemId;
  var totalQuantity = 0;

  if ($currentCheckBox.is(':checked')) {
    if($('.cart-drawer .jsc-cart-item-giftwrap').length > 0 ) {
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        totalQuantity = totalQuantity + parseInt($(this).find('quantity-selector input').val());
      });
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        var giftWrapVariantID = $(this).attr('data-product-variant-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == bindID && ($('.jsc-limit-giftwrap').length <= 0)) {
          var selectedGiftWrapVarID = giftWrapVarID; 
          console.log("selectedGiftWrapVarID", selectedGiftWrapVarID);

          var jsonObj = {};
          var currentGiftWrapQty = parseInt($(this).find('quantity-selector input').val()); // 8 | 1
          var maxQtyToBeAdd = 10 - totalQuantity; // 9 = 1
          var currentQTYAdded = currentQuantity - currentGiftWrapQty; // 11 - 8 = 3
          
          if(currentQTYAdded < maxQtyToBeAdd){
            var actualQtyAdded = currentGiftWrapQty + currentQTYAdded;
          }else{
            var actualQtyAdded = currentGiftWrapQty + maxQtyToBeAdd;
          }
          jsonObj[selectedGiftWrapVarID] = actualQtyAdded;

          // CartJS.updateItemById(selectedGiftWrapVarID, 0, {}, {
          //   success: function(data, textStatus, jqXHR) {
          //     console.log('Success in removing gift wrap', data); // Removed undefined variable itemId
          //   },
          //   error: function(jqXHR, textStatus, errorThrown) {
          //     console.error('Error updating cart item properties after removing gift wrap:', errorThrown); // Corrected to errorThrown
          //   }
          // });
          // CartJS.addItem(giftWrapVariantID, currentQuantity, {"_giftWrap bindID": bindID, "_giftWrap Product": "giftWrap"}, {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Remove item - updateItemQuantitiesById-variant-id', jqXHR);
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while updating item quantities:", errorThrown);
          //   }
          // });
          CartJS.updateItemQuantitiesById(jsonObj, {
            "success": function(data, textStatus, jqXHR) {
              console.log('Remove item - updateItemQuantitiesById-key-id', jqXHR);
              // location.reload();
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log("Error occurred while updating item quantities:", errorThrown);
            }
          });

          // CartJS.removeItemById(selectedGiftWrapVarID, {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Remove item - removeItemById - variant-id', jqXHR);
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while updating item quantities:", errorThrown);
          //   }
          // });
        
          // CartJS.addItems([{id: giftWrapVariantID, quantity: currentQuantity, properties: { "_giftWrap bindID": bindID, "_giftWrap Product": "giftWrap"}}], {
          //   "success": function(data, textStatus, jqXHR) {
          //     console.log('Success in adding items');
          //   },
          //   "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log("Error occurred while adding items:", errorThrown, jqXHR);
          //   }
          // });
          
        }
      });
    }
  }
}

removeGiftAndMainItemLineItemProperties = () => {
  var checkCount = 0;
  var maxChecks = 10;
  var intervalTime = 1000;
  var intervalId = setInterval(() => {
    checkCount++;
    if ($('.jsc-remove-gift-and-line-item-properties').length > 0) {
      $('.checkout-button').attr('disabled', true);

      var totalItems = $('.jsc-remove-gift-and-line-item-properties').length;
      var processedItems = 0;

      $('.jsc-remove-gift-and-line-item-properties').each(function() {
        var main_item_key = $(this).attr('main-item-key');
        var main_item_qty = parseInt($(this).attr('main-item-qty'));
        var giftwrap_item_key = $(this).attr('giftwrap-item-key');
        console.log("TEST", main_item_key, main_item_qty, giftwrap_item_key);

        CartJS.updateItemById(main_item_key, main_item_qty, { 
          "Gift wrap": null, 
          "giftWrap bindID": null 
        });

        CartJS.updateItemById(giftwrap_item_key, 0);
        
        processedItems++;

        if (processedItems === totalItems) {
          clearInterval(intervalId);
        }
      });
    }

    if (checkCount >= maxChecks) {
      clearInterval(intervalId);
    }
  }, intervalTime);
}

updateGiftWrap = () =>{
  if ($('.jsc-update-giftwrap').length > 0) {
    $('.checkout-button').attr('disabled', true);
    $('.jsc-update-giftwrap').each(function(){
      var varID = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      var jsonObj = {};
      jsonObj[varID] = QTY;
      CartJS.updateItemQuantitiesById(jsonObj, {
        "success": function(data, textStatus, jqXHR) {
          console.log('Remove item - updateItemQuantitiesById-key-id', jqXHR);
          // location.reload();
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occurred while updating item quantities:", errorThrown);
        }
      });
    });
  }
}

removeMainProdLineItemProperties = () => {
  if ($('.jsc-remove-main-prod-line-item-properties').length > 0) {
    $('.checkout-button').attr('disabled', true);
    $('.jsc-remove-main-prod-line-item-properties').each(function(){
      var main_item_key = $(this).attr('main-item-key');
      var main_item_qty = parseInt($(this).attr('main-item-qty'));

      CartJS.updateItemById(main_item_key, main_item_qty,  {"Gift wrap": null, "giftWrap bindID": null});
    });
  }
}

copyPDPLink = () => {
  var currentURL = window.location.href;
  navigator.clipboard.writeText(currentURL)
    .then(() => {$(".success-copy-message").css("display", "flex");
      setTimeout(() => {
        $(".success-copy-message").css("display", "none");
      }, 2000);})
    .catch(err => console.error("Failed to copy URL: ", err));
}
// Start - bundle option to create from list
opencloseselectprod = (evt) => {
  const $evt = $(evt);
  const $target = $evt.siblings('.opt-bundle-prod');
  const $container = $evt.closest('.bundle-select-prod-main');

  // Toggle current element
  $target.toggle();

  // Hide other elements
  $container.find('.opt-bundle-prod').not($target).hide();

  // Click outside handler to close options
  $(document).off('click.closeOptions').on('click.closeOptions', (e) => {
    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
        $target.hide();
        $(document).off('click.closeOptions'); // Remove the handler once closed
    }
  });
}

onclickselecrprod = (evt,selectmorethanone) => {
  const $evt = $(evt);
  const selectno = $evt.data('select-no')
  const prodTitle = $evt.data('prod-title');
  const prodId = $evt.data('prod-id');

  const $bundleMain = $evt.closest('.bundle-select-prod-main');
  const $optBundleProd = $evt.closest('.opt-bundle-prod');
  const $prodBundleSelect = $evt.closest('.prod-bundle-select');

  const $selectedBundleVar = $prodBundleSelect.find('.selected-prod-bundle-var');
  const $selectedBundleTitle = $evt.closest('.select-opt-bundle-wrap').find('.selected-bundle-prod-title');

  // Clone and prepare the selected product
  const $prodSelectedVar = $bundleMain
    .siblings(`.bundlenocreate[data-product-id="${prodId}"]`)
    .clone()
    .removeClass('bundlenocreate');

  // Update active state
  $optBundleProd.find('.active-bundle-select').removeClass('active-bundle-select');
  $evt.addClass('active-bundle-select');

  // Update selected product title and variants
  $selectedBundleTitle.text(prodTitle);
  $selectedBundleVar.empty();

  if (prodId !== 'default') {
    $prodSelectedVar.find('input').each(function () {
      var $input = $(this);
      var color = $input.data('value-nospace');
      var productId = $input.data('product-id');
      var inputnamedefault = $input.attr('name');
      var templateId = "24341136507249__main-product"; // Adjust if dynamic
    
      var newId = `swatch-0-bundle-${selectno}-${color}-${productId}-template--${templateId}`;
      var newName = `${inputnamedefault}-${selectno}`;
      $input.attr('id', newId);
      $input.attr('name', newName);
    
      var $label = $input.siblings('label'); // Assumes label is sibling
      if ($label.length > 0) {
        $label.attr('for', newId);
      }
    });

    $selectedBundleVar.append($prodSelectedVar);
    $selectedBundleVar.find('.jsc-each-swatch input[checked]').next().click();
  }

  // Hide current bundle selection and reset visibility
  $optBundleProd.hide();
  const $bundleItems = $bundleMain.find('.opt-bundle-prod li').show();

  // Hide duplicate product options
  $bundleItems.filter('.active-bundle-select').each(function () {
    const prodIdCheck = $(this).data('prod-id');
    if (prodIdCheck !== 'default' && selectmorethanone == 'false') {
      $bundleItems.filter(`[data-prod-id="${prodIdCheck}"]:not(.active-bundle-select)`).hide();
    }
  });
  if (prodId == 'default') {
    $evt.parents('.bundle-select-prod-main').find(".feature-img-bundle").each(function () {
      var indeximg = $evt.parents('.prod-bundle-select').find('.feature-img-bundle').index(this);

      $(evt).parents('.thb-product-detail').find('.product-single__media .bundle-img-list').each(function(index) {
        if (index === indeximg) {
          const featimg = $(this).attr('data-default-src');
          // Widths you want in srcset
          var widths = [352, 832, 1200, 1920, 2000];

          // Build srcset by appending `&width=...` to featimg
          var srcset = widths.map(function(w) {
            return featimg + "&width=" + w + " " + w + "w";
          }).join(", ");

          $(this).attr('src', featimg + "&width=2000"); // Update src to high-res
          $(this).attr('srcset', srcset); // Update srcset with different sizes
        }
      });
      $(evt).parents('.thb-product-detail').find('.navCell .bundle-img-list').each(function(index) {
        if (index === indeximg) {
          const featimgnav = $(this).attr('data-default-src');
          $(this).attr('src', featimgnav); // Update src to high-res
        }
      });
    });
    $evt.parents('.prod-bundle-select').find('.feature-img-bundle').hide();
    $evt.parents('.prod-bundle-select').find('.opt-wrap').removeClass('opt-wrap-set');
    variantImageSwap('');
    if ($('.prod-bundle-select').length != $('.prod-bundle-select .bundle-prod-var').length) {
      $('.bundle-atc-form').attr('onclick', '');
    }
  }
}
// End - bundle option to create from list